import { A, C as E, a as v, P as C, b as W, c as g, N as x } from "./cart-machine-DaahVifl.js";
import { d as Ge } from "./cart-machine-DaahVifl.js";
import { s as K, c as z, a as p, e as f, f as V, Q as j, M as y, p as J } from "./vendor-DxSylgwR.js";
import { R as q, a as D } from "./reservation-machine-BrOyOFNE.js";
import { b as Ye } from "./reservation-machine-BrOyOFNE.js";
var I = /* @__PURE__ */ ((s) => (s.JSON = "application/json", s.XML = "application/xml", s.HTML = "text/html", s.Text = "text/plain", s.JavaScript = "application/javascript", s.CSS = "text/css", s.FormData = "multipart/form-data", s.UrlEncoded = "application/x-www-form-urlencoded", s.EventStream = "text/event-stream", s.PDF = "application/pdf", s.ApplePkPass = "application/vnd.apple.pkpass", s.ApplePkPasses = "application/vnd.apple.pkpasses", s))(I || {});
class l {
  constructor(e) {
    this.services = e, this.config = this.services.configManager.getConfig(), this.baseHeaders = {
      Accept: I.JSON,
      __tenant: this.config.tenant,
      "Accept-Language": this.config.locale ?? navigator.language ?? "ar"
    };
    const t = localStorage.getItem("access_token");
    t && (this.setAuthorizationHeader(t), this.checkTokenForCustomerId(t).catch((r) => {
      console.error("Failed to check token during initialization:", r);
    })), this.setupCrossTabSync();
  }
  config;
  requestInterceptors = [];
  responseInterceptors = [];
  baseHeaders;
  isRefreshing = !1;
  pendingRequests = [];
  refreshPromise = null;
  refreshAttempts = 0;
  lastRefreshAttempt = 0;
  static REFRESH_LOCK_KEY = "token_refresh_lock";
  static REFRESH_LOCK_TIMEOUT = 3e4;
  static REFRESH_TIMESTAMP_KEY = "token_refresh_timestamp";
  static TOKEN_FRESHNESS_WINDOW = 5e3;
  static MAX_REFRESH_ATTEMPTS = 3;
  static REFRESH_ATTEMPT_WINDOW = 3e4;
  setAuthorizationHeader(e) {
    e ? this.baseHeaders.Authorization = `Bearer ${e}` : delete this.baseHeaders.Authorization;
  }
  async checkTokenForCustomerId(e) {
    try {
      this.parseJwt(e)?.CustomerId || (console.log("Token missing CustomerId, refreshing token..."), await this.refreshToken());
    } catch (t) {
      console.error("Error checking token for CustomerId:", t);
    }
  }
  parseJwt(e) {
    try {
      const r = e.split(".")[1]?.replace(/-/g, "+").replace(/_/g, "/");
      if (!r) throw new Error("base64Url is empty or null");
      const i = decodeURIComponent(
        atob(r).split("").map((a) => "%" + ("00" + a.charCodeAt(0).toString(16)).slice(-2)).join("")
      );
      return JSON.parse(i);
    } catch (t) {
      return console.error("Error parsing JWT:", t), null;
    }
  }
  logoutUser() {
    console.log("Logging out user due to persistent authentication failure"), localStorage.removeItem("access_token"), localStorage.removeItem("refresh_token"), localStorage.removeItem(l.REFRESH_TIMESTAMP_KEY), this.setAuthorizationHeader(null);
  }
  /**
   * Add a request interceptor to the client
   * @param interceptor The interceptor to add
   * @returns A function that removes the interceptor from the client
   * @example const removeInterceptor = client.addRequestInterceptor(interceptor);
   */
  addRequestInterceptor(e) {
    return this.requestInterceptors.push(e), () => {
      const t = this.requestInterceptors.indexOf(e);
      t !== -1 && this.requestInterceptors.splice(t, 1);
    };
  }
  /**
   * Add a response interceptor to the client
   * @param interceptor The interceptor to add
   * @returns A function that removes the interceptor from the client
   * @example const removeInterceptor = client.addResponseInterceptor(interceptor);
   */
  addResponseInterceptor(e) {
    return this.responseInterceptors.push(e), () => {
      const t = this.responseInterceptors.indexOf(e);
      t !== -1 && this.responseInterceptors.splice(t, 1);
    };
  }
  async performFetch(e) {
    const t = this.buildUrl(
      e.path,
      e.version,
      e.params,
      e.query
    ), r = {
      ...this.baseHeaders,
      ...e.headers
    };
    !r["Content-Type"] && !(e.body instanceof FormData) && (r["Content-Type"] = I.JSON), e.body instanceof FormData && r["Content-Type"] && delete r["Content-Type"];
    const i = {
      method: e.method,
      headers: r
    };
    e.body && (e.body instanceof FormData ? i.body = e.body : r["Content-Type"] === "application/x-www-form-urlencoded" ? i.body = new URLSearchParams(
      e.body
    ).toString() : i.body = JSON.stringify(e.body));
    const a = await fetch(t, i);
    if (!a.ok)
      throw await this.handleErrorResponse(a, e);
    const n = a.headers.get("content-type");
    let o;
    return n && n.includes(I.JSON) ? o = await a.json() : o = await a.text(), {
      data: o,
      meta: {
        version: e.version ?? "1",
        requestId: a.headers.get("x-request-id")
      }
    };
  }
  async request(e) {
    this.refreshPromise && await this.refreshPromise;
    const t = localStorage.getItem("access_token");
    t && !e.isRetry && await this.checkTokenForCustomerId(t);
    try {
      let r = this.clone(e);
      r.body = e.body;
      for (const i of this.requestInterceptors)
        i.onRequest && (r = await i.onRequest(r));
      try {
        let a = await this.performFetch(r);
        for (const n of this.responseInterceptors)
          n.onResponse && (a = await n.onResponse(a));
        return a;
      } catch (i) {
        let a = i;
        for (const n of this.requestInterceptors)
          n.onRequestError && (a = await n.onRequestError(
            a
          ));
        if (a instanceof A && a.status === 401 && a.config && !a.config.isRetry && !a.config.path.includes("/auth/refresh"))
          try {
            return await this.handleUnauthorizedError(a.config);
          } catch (n) {
            a = n;
          }
        a instanceof A && a.status === 401 && a.config?.isRetry && (console.error("Still getting 401 after token refresh - logging out"), this.logoutUser());
        for (const n of this.responseInterceptors)
          if (n.onResponseError) {
            const o = a instanceof E ? a : new E(
              a.message,
              v.UNKNOWN,
              void 0,
              void 0,
              a
            );
            a = await n.onResponseError(o);
          }
        throw this.services.errorHandler.normalizeError(a);
      }
    } catch (r) {
      throw this.services.errorHandler.normalizeError(r);
    }
  }
  buildUrl(e, t, r, i) {
    const a = t ? `/v${t}` : "";
    let n = e.startsWith("http") ? e : `${this.config.baseUrl}${a}/${e.replace(/^\//, "")}`;
    if (r) {
      for (const o in r)
        if (Object.prototype.hasOwnProperty.call(r, o)) {
          const c = r[o];
          if (c == null) continue;
          Array.isArray(c) ? (console.warn(
            `Array provided for path parameter :${o}. Using first element.`
          ), n = n.replace(`:${o}`, encodeURIComponent(String(c[0])))) : n = n.replace(`:${o}`, encodeURIComponent(String(c)));
        }
    }
    if (/\/:[a-zA-Z0-9_]+/.test(n) && console.warn(`URL still contains unreplaced path parameters: ${n}`), i) {
      const o = Object.keys(i).filter((c) => i[c] !== void 0 && i[c] !== null).map((c) => {
        const h = i[c];
        return Array.isArray(h) ? h.map(
          (d) => `${encodeURIComponent(c)}=${encodeURIComponent(String(d))}`
        ).join("&") : typeof h == "object" && h !== null ? Object.entries(h).map(
          ([d, u]) => `${encodeURIComponent(c)}[${encodeURIComponent(d)}]=${encodeURIComponent(String(u))}`
        ).join("&") : `${encodeURIComponent(c)}=${encodeURIComponent(String(h))}`;
      }).join("&");
      o && (n += (n.includes("?") ? "&" : "?") + o);
    }
    return n;
  }
  async handleErrorResponse(e, t) {
    let r = null;
    try {
      const n = await e.text();
      n && (r = JSON.parse(n));
    } catch (n) {
      console.warn("Failed to parse error response body:", n);
    }
    const i = r?.message || r?.error?.message || (typeof r == "string" ? r : null) || e.statusText || `HTTP error ${e.status}`, a = r?.error?.code || v.API_ERROR;
    throw new A(
      a,
      i,
      e.status,
      r,
      {},
      t
    );
  }
  async refreshToken() {
    const e = Date.now();
    if (e - this.lastRefreshAttempt > l.REFRESH_ATTEMPT_WINDOW && (this.refreshAttempts = 0), this.refreshAttempts >= l.MAX_REFRESH_ATTEMPTS)
      throw console.error(
        `Max refresh attempts (${l.MAX_REFRESH_ATTEMPTS}) reached - logging out`
      ), this.logoutUser(), new Error("Maximum token refresh attempts exceeded");
    this.refreshAttempts++, this.lastRefreshAttempt = e, console.log(
      `Refreshing token... (attempt ${this.refreshAttempts}/${l.MAX_REFRESH_ATTEMPTS})`
    );
    const t = localStorage.getItem("refresh_token");
    if (!t)
      throw new Error("No refresh token available.");
    const r = `${this.config.baseUrl}/connect/token`, i = new URLSearchParams({
      grant_type: "refresh_token",
      client_id: "Platform_EndCustomer",
      refresh_token: t
    });
    try {
      const a = await fetch(r, {
        method: "POST",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded",
          Accept: I.JSON,
          __tenant: this.config.tenant
        },
        body: i.toString()
      });
      if (!a.ok) {
        let d = null;
        try {
          d = await a.json();
        } catch {
        }
        const u = d?.message || a.statusText || `Refresh failed with status ${a.status}`;
        throw (a.status === 401 || a.status === 403) && (console.error("Refresh token invalid or expired. Clearing tokens."), localStorage.removeItem("access_token"), localStorage.removeItem("refresh_token"), localStorage.removeItem(l.REFRESH_TIMESTAMP_KEY), this.setAuthorizationHeader(null)), new A(
          v.API_ERROR,
          u,
          a.status,
          d
        );
      }
      const n = await a.json();
      console.log("Token refreshed successfully");
      const { access_token: o, refresh_token: c } = n;
      if (!o)
        throw new Error("Refresh response did not include an access_token.");
      this.refreshAttempts = 0, localStorage.setItem("access_token", o), c && localStorage.setItem("refresh_token", c), this.setAuthorizationHeader(o), localStorage.setItem(
        l.REFRESH_TIMESTAMP_KEY,
        Date.now().toString()
      ), this.parseJwt(o)?.CustomerId || console.warn("New token still missing CustomerId after refresh");
    } catch (a) {
      throw console.error("Error during token refresh:", a), a instanceof A && (a.status === 401 || a.status === 403) && localStorage.getItem("access_token") && (localStorage.removeItem("access_token"), localStorage.removeItem("refresh_token"), localStorage.removeItem(l.REFRESH_TIMESTAMP_KEY), this.setAuthorizationHeader(null)), a;
    }
  }
  handleUnauthorizedError(e) {
    if (this.isTokenFresh()) {
      console.log(
        "Token was recently refreshed by another tab, using fresh token"
      );
      const t = localStorage.getItem("access_token");
      if (t)
        return this.setAuthorizationHeader(t), e.isRetry = !0, this.performFetch(e);
    }
    return this.refreshPromise ? console.log(
      "Token refresh already in progress, adding request to queue:",
      e.path
    ) : this.tryAcquireLock() ? (console.log("Acquired lock. Starting token refresh process"), this.isRefreshing = !0, this.refreshPromise = this.refreshToken().then(() => {
      console.log(
        `Token refreshed successfully. Processing ${this.pendingRequests.length} pending requests.`
      ), this.pendingRequests.forEach((t) => {
        t.config.isRetry = !0, this.performFetch(t.config).then(t.resolve).catch((r) => {
          r instanceof A && r.status === 401 && (console.error(
            "Request still unauthorized after token refresh - logging out"
          ), this.logoutUser()), t.reject(r);
        });
      }), this.pendingRequests = [];
    }).catch((t) => {
      throw console.error(
        "Token refresh failed. Rejecting all pending requests:",
        t
      ), localStorage.removeItem("access_token"), localStorage.removeItem("refresh_token"), localStorage.removeItem(l.REFRESH_TIMESTAMP_KEY), this.setAuthorizationHeader(null), this.pendingRequests.forEach((r) => r.reject(t)), this.pendingRequests = [], t;
    }).finally(() => {
      this.releaseLock(), this.isRefreshing = !1, this.refreshPromise = null;
    })) : (console.log(
      "Lock already held by another tab. Waiting for token refresh..."
    ), this.refreshPromise = this.waitForTokenRefresh().then(() => {
      const t = localStorage.getItem("access_token");
      if (t)
        this.setAuthorizationHeader(t);
      else
        throw new Error(
          "Token refresh completed but no access token found"
        );
    })), new Promise((t, r) => {
      this.isRefreshing && e.path !== "/auth/refresh" ? this.pendingRequests.push({
        resolve: t,
        reject: r,
        config: e
      }) : this.refreshPromise.then(async () => (console.log(
        "Token refreshed. Retrying request:",
        e.path
      ), e.isRetry = !0, this.performFetch(e))).then(t).catch((i) => {
        i instanceof A && i.status === 401 && (console.error(
          "Request still unauthorized after token refresh - logging out"
        ), this.logoutUser()), r(i);
      });
    });
  }
  setLocale(e) {
    this.baseHeaders["Accept-Language"] = e;
  }
  getLocale() {
    return this.baseHeaders["Accept-Language"] || "ar";
  }
  clone(e) {
    try {
      return JSON.parse(JSON.stringify(e));
    } catch (t) {
      return console.error("Failed to clone object, returning original:", e, t), e;
    }
  }
  setupCrossTabSync() {
    window.addEventListener("storage", (e) => {
      if (e.key === l.REFRESH_TIMESTAMP_KEY && e.newValue) {
        const t = localStorage.getItem("access_token");
        t && this.isTokenFresh() && this.handleFreshTokenDetected(t);
      }
    });
  }
  isTokenFresh() {
    const e = localStorage.getItem(
      l.REFRESH_TIMESTAMP_KEY
    );
    return e ? Date.now() - parseInt(e, 10) < l.TOKEN_FRESHNESS_WINDOW : !1;
  }
  handleFreshTokenDetected(e) {
    console.log("Fresh token detected from another tab"), this.setAuthorizationHeader(e), this.checkTokenForCustomerId(e).catch((t) => {
      console.error("Failed to check token from another tab:", t);
    }), this.refreshPromise && !this.isRefreshing && (this.refreshPromise = Promise.resolve()), this.pendingRequests.length > 0 && (console.log(
      `Processing ${this.pendingRequests.length} pending requests after token refresh from another tab`
    ), this.pendingRequests.forEach((t) => {
      t.config.isRetry = !0, this.performFetch(t.config).then(t.resolve).catch(t.reject);
    }), this.pendingRequests = []);
  }
  tryAcquireLock() {
    const e = Date.now(), t = localStorage.getItem(l.REFRESH_LOCK_KEY);
    if (t) {
      const r = parseInt(t, 10);
      if (e - r < l.REFRESH_LOCK_TIMEOUT)
        return !1;
    }
    return localStorage.setItem(l.REFRESH_LOCK_KEY, e.toString()), !0;
  }
  releaseLock() {
    localStorage.removeItem(l.REFRESH_LOCK_KEY);
  }
  waitForTokenRefresh() {
    return new Promise((e, t) => {
      const i = l.REFRESH_LOCK_TIMEOUT;
      let a = 0, n = localStorage.getItem("access_token");
      const o = setInterval(() => {
        a += 100;
        const c = localStorage.getItem("access_token");
        if (c !== n && c && this.isTokenFresh()) {
          clearInterval(o), this.setAuthorizationHeader(c), this.pendingRequests.length > 0 && (console.log(
            `Processing ${this.pendingRequests.length} pending requests after detecting token change`
          ), this.pendingRequests.forEach((d) => {
            d.config.isRetry = !0, this.performFetch(d.config).then(d.resolve).catch(d.reject);
          }), this.pendingRequests = []), e();
          return;
        }
        if (!localStorage.getItem(l.REFRESH_LOCK_KEY)) {
          clearInterval(o), e();
          return;
        }
        a >= i && (clearInterval(o), t(new Error("Token refresh timeout")));
      }, 100);
    });
  }
}
class X extends l {
  CLIENT_ID = "Platform_EndCustomer";
  SCOPE = "openid email profile offline_access EndCustomer";
  GRANT_TYPE = "mobile_number";
  BASE_URL = "/api/auth";
  constructor(e) {
    super(e);
  }
  // async requestOtp(phoneNumber: string) {
  //   const response = await this.request<RequestOtpResponse>({
  //     method: "POST",
  //     path: this.BASE_URL + "/send-otp",
  //     body: {
  //       identifier: phoneNumber
  //     }
  //   });
  //
  //   return response.data;
  // }
  // async requestOtp(phoneNumber: string) {
  //   const response = await this.axiosInstance.post("/api/app/otp", {
  //     mobileNumber: phoneNumber,
  //     purpose: 0,
  //   });
  //   return response.data;
  // }
  async requestOtp(e) {
    return (await this.request({
      method: "POST",
      path: "/api/app/otp",
      body: {
        mobileNumber: e,
        purpose: 0
        // Assuming 0 is the purpose for OTP request
      }
    })).data;
  }
  async login(e, t) {
    return (await this.request({
      method: "POST",
      path: "/connect/token",
      body: new URLSearchParams({
        grant_type: this.GRANT_TYPE,
        client_id: this.CLIENT_ID,
        otp: t,
        scope: this.SCOPE,
        token: e
      }),
      headers: {
        "Content-Type": "application/x-www-form-urlencoded"
      }
    })).data;
  }
  // async login(otpToken: string, otpCode: string) {
  //   const response = await this.request<LoginResponse>({
  //     method: "POST",
  //     path: this.BASE_URL + "/otp-login",
  //     body: {
  //       credentials: {
  //         otpToken: otpToken,
  //         otpCode: otpCode
  //       },
  //       scopes: this.SCOPE.split(" "),
  //       clientId: this.CLIENT_ID,
  //       grantType: this.GRANT_TYPE
  //     }
  //   });
  //
  //   return response.data;
  // }
  // async logout() {
  //   await this.request<LogoutResponse>({
  //     method: "POST",
  //     path: this.BASE_URL + "/logout"
  //   });
  // }
  async currentUser() {
    try {
      const e = await this.request({
        method: "GET",
        path: this.BASE_URL + "/current-user"
      });
      return e.data ? (console.log("User info received:", e.data), e.data) : (console.warn("Received success status but no user data."), null);
    } catch (e) {
      if (e.response?.status === 401)
        return console.log("User is not authenticated."), null;
      throw console.error("Error fetching user info:", e), this.services.errorHandler.handleError(e), e;
    }
  }
}
function Z(s) {
  switch (s) {
    case C.MADA:
      return 2;
    case C.VISA:
      return 2;
    case C.CASH:
      return 1;
    case C.APPLE_PAY:
      return 2;
    case C.TAMARA:
      return 2;
    case C.TABBY:
      return 2;
    case C.BANK_TRANSFER:
      return 3;
    default:
      return 1;
  }
}
const ee = (s) => {
  for (const e of s)
    if (e.stock.isUnlimited || e.stock.availableQuantity > 0)
      return e;
  return s[0];
};
class te extends l {
  BASE_PATH = "/api/app/cart";
  constructor(e) {
    super(e);
  }
  async createCart(e) {
    return (await this.request({
      method: "POST",
      path: this.BASE_PATH + "/new-cart",
      body: e
    })).data;
  }
  async getCart(e) {
    return (await this.request({
      method: "GET",
      path: this.BASE_PATH + "/:id",
      params: { id: e }
    })).data;
  }
  async getCartSSE(e, t) {
    const r = this.buildUrl("/api/sse/cart", void 0, void 0, {
      cartId: e,
      tenantId: t
    });
    return new EventSource(r, {
      withCredentials: !0
    });
  }
  async getCartStatusSSE(e, t, r) {
    const i = { cartId: e, tenantId: t };
    r && (i.from = r), console.log("getCartStatusSSE", i);
    const a = this.buildUrl(
      "/api/sse/cart/status",
      void 0,
      void 0,
      i
    );
    return new EventSource(a, {
      withCredentials: !0
    });
  }
  async addItems(e, t, r) {
    return (await this.request({
      method: "POST",
      path: this.BASE_PATH + "/cart-items/:cartId",
      params: { cartId: e },
      query: { singleItem: r },
      body: t
    })).data;
  }
  async removeItems(e, t) {
    return (await this.request({
      method: "DELETE",
      path: this.BASE_PATH + "/cart-items/:cartId",
      params: { cartId: e },
      query: { itemsIds: t }
    })).data;
  }
  async updateItems(e, t) {
    return (await this.request({
      method: "PUT",
      path: this.BASE_PATH + "/items/:cartId",
      params: { cartId: e },
      body: t
    })).data;
  }
  async updateCoupon(e, t) {
    return (await this.request({
      method: "PUT",
      path: this.BASE_PATH + "/coupon/:cartId",
      params: { cartId: e },
      query: { couponCode: t }
    })).data;
  }
  async updateCart(e, t) {
    return (await this.request({
      method: "PUT",
      path: this.BASE_PATH + "/:cartId",
      params: { cartId: e },
      body: { cart: t }
    })).data;
  }
  async updateCustomFields(e, t, r) {
    return (await this.request({
      method: "POST",
      path: this.BASE_PATH + "/custom-fields",
      query: { cartId: e, cartItemId: t },
      body: r
    })).data;
  }
  async updateNotes(e, t) {
    return (await this.request({
      method: "PUT",
      path: this.BASE_PATH + "/notes/:cartId",
      params: { cartId: e },
      query: { notes: t }
    })).data;
  }
  async updateCustomerIdentity(e, t) {
    return (await this.request({
      method: "PUT",
      path: this.BASE_PATH + "/customer/:cartId",
      params: { cartId: e },
      query: {
        name: t.name,
        mobileNumber: t.phone,
        otpToken: t.otpToken
      },
      body: t.customFields
    })).data;
  }
  async validateCoupon(e) {
    return (await this.request({
      method: "POST",
      path: "api/app/coupon/check-coupon",
      body: e
    })).data;
  }
  async submitCart(e, t) {
    const r = Z(t);
    return (await this.request({
      method: "POST",
      path: this.BASE_PATH + "/:payload/process",
      params: { payload: e },
      query: { paymentMethod: r }
    })).data;
  }
  async getOrder(e, t = !1) {
    return (await this.request({
      method: "GET",
      path: this.BASE_PATH + "/:orderId",
      params: { orderId: e },
      query: { allowNonPending: t }
    })).data;
  }
  async validateCart(e) {
    return (await this.request({
      method: "POST",
      path: this.BASE_PATH + "/validate-cart/:cartId",
      params: { cartId: e }
    })).data;
  }
  async setBankTransferInfo(e, t, r) {
    return (await this.request({
      method: "POST",
      path: this.BASE_PATH + "/set-bank-transfer-info/:cartId",
      params: { cartId: e },
      query: { transferorName: t },
      body: r,
      headers: {
        "Content-Type": "multipart/form-data"
      }
    })).data;
  }
  async downloadAppleWalletPass(e) {
    return (await this.request({
      method: "GET",
      path: "/api/app/wallet-passes/apple-wallet/:productType/:payableItemGroupId",
      params: {
        productType: e.product.typeString,
        payableItemGroupId: e.payableItemGroupId
      }
    })).data;
  }
  async downloadAppleWalletPassBundle(e) {
    return (await this.request({
      method: "GET",
      path: "/api/app/wallet-passes/apple-wallet/cart/:id",
      params: { id: e },
      headers: {
        Accept: I.ApplePkPasses
      }
    })).data;
  }
  async getBankAccounts() {
    return (await this.request({
      method: "GET",
      path: "/api/app/bank-account/bank-account"
    })).data;
  }
  async getCustomerOrders(e) {
    return (await this.request({
      method: "GET",
      path: this.BASE_PATH + "/orders",
      query: {
        Sorting: e?.sorting,
        SkipCount: e?.skipCount,
        MaxResultCount: e?.maxResultCount
      }
    })).data;
  }
}
class re extends l {
  BASE_PATH = "/api/app/setting-manager";
  BRANCH_BASE_PATH = "/api/app/branch";
  constructor(e) {
    super(e);
  }
  async getTenantConfig() {
    return (await this.request({
      method: "GET",
      path: this.BASE_PATH + "/payment-and-tax-settings"
    })).data;
  }
  async getBranchList() {
    return (await this.request({
      method: "GET",
      path: this.BRANCH_BASE_PATH + "/branch-list"
    })).data;
  }
}
class se extends l {
  BASE_PATH = "/api/app/identity-customer";
  PRESET_PATH = "/api/app/presets";
  CUSTOMER_LOCATION_PATH = "/api/app/customer-locations";
  constructor(e) {
    super(e);
  }
  async getCustomerProfile() {
    return (await this.request({
      method: "GET",
      path: this.BASE_PATH
    })).data;
  }
  async updateCustomerProfile(e) {
    const t = e.token ? {
      headers: {
        Authorization: `Bearer ${e.token}`
      }
    } : {};
    return (await this.request({
      method: "PUT",
      path: this.BASE_PATH,
      body: e,
      ...t
    })).data;
  }
  async getPresetValues(e) {
    return (await this.request({
      method: "GET",
      path: this.PRESET_PATH + "/values",
      query: {
        presetId: e
      }
    })).data;
  }
  async getPresetsWithValues() {
    return (await this.request({
      method: "GET",
      path: this.PRESET_PATH + "/presets-with-values/"
    })).data;
  }
  async getCustomerOrders(e = 5, t = 0) {
    return (await this.request({
      method: "GET",
      path: this.BASE_PATH + "/orders",
      query: {
        SkipCount: t,
        MaxResultCount: e
      }
    })).data;
  }
  async getAllPresets() {
    return (await this.request({
      method: "GET",
      path: this.PRESET_PATH + "/presets-list"
    })).data;
  }
  async getPresetFields(e) {
    return (await this.request({
      method: "GET",
      path: this.PRESET_PATH + "/preset-fields-with-values",
      query: {
        presetId: e
      }
    })).data;
  }
  async addPresetValueGroup(e, t) {
    return (await this.request({
      method: "POST",
      path: this.PRESET_PATH + "/value",
      query: {
        presetId: e
      },
      body: t
    })).data;
  }
  async editPresetValueGroup(e, t) {
    return (await this.request({
      method: "PUT",
      path: this.PRESET_PATH + "/values/:presetGroupId",
      params: { presetGroupId: e },
      body: t
    })).data;
  }
  async setDefaultGroup(e) {
    return (await this.request({
      method: "POST",
      path: this.PRESET_PATH + "/set-default-group/:presetGroupId",
      params: { presetGroupId: e }
    })).data;
  }
  async deletePresetValueGroup(e) {
    return (await this.request({
      method: "DELETE",
      path: this.PRESET_PATH + "/:presetGroupId",
      params: { presetGroupId: e }
    })).data;
  }
  async getCustomerLocations() {
    return (await this.request({
      method: "GET",
      path: this.CUSTOMER_LOCATION_PATH
    })).data;
  }
  async getCustomerLocation(e) {
    return (await this.request({
      method: "GET",
      path: this.CUSTOMER_LOCATION_PATH + "/:locationId",
      params: { locationId: e }
    })).data;
  }
  async addCustomerLocation(e) {
    return (await this.request({
      method: "POST",
      path: this.CUSTOMER_LOCATION_PATH,
      body: e
    })).data;
  }
  async updateCustomerLocation(e) {
    return (await this.request({
      method: "PUT",
      path: this.CUSTOMER_LOCATION_PATH + "/:locationId",
      params: { locationId: e.id },
      body: e
    })).data;
  }
  async deleteCustomerLocation(e) {
    return (await this.request({
      method: "DELETE",
      path: this.CUSTOMER_LOCATION_PATH + "/:locationId",
      params: { locationId: e }
    })).data;
  }
  async getClosestCustomerLocation(e, t) {
    return (await this.request({
      method: "GET",
      path: this.CUSTOMER_LOCATION_PATH + "/closest",
      query: {
        longitude: e,
        latitude: t
      }
    })).data;
  }
  async getCustomerPackages(e, t) {
    return (await this.request({
      method: "GET",
      path: "/api/app/package/customer-packages/:customerId",
      params: { customerId: e },
      query: t ? { includeAllPackageItems: t } : void 0
    })).data;
  }
  async getActiveSubscription() {
    return (await this.request({
      method: "GET",
      path: this.BASE_PATH + "/customer-subscription"
    })).data;
  }
}
class ie extends l {
  constructor(e) {
    super(e);
  }
  async createMoyasarToken(e, t) {
    return (await this.request({
      method: "POST",
      path: "https://api.moyasar.com/v1/tokens",
      body: e,
      headers: {
        Authorization: "Basic " + btoa(t + ":")
      }
    })).data;
  }
  async createMoyasarSession(e) {
    return (await this.request({
      method: "POST",
      path: "/payment/moyasar/session",
      body: e
    })).data;
  }
  async createMoyasarApplePaySession(e) {
    return (await this.request({
      method: "POST",
      path: "https://api.moyasar.com/v1/applepay/initiate",
      body: e
    })).data;
  }
  async createMyFatoorahSession(e, t, r) {
    return (await this.request({
      method: "POST",
      path: "/api/app/payment/initiate-session/:customerId",
      params: { customerId: e },
      query: {
        callbackUrl: t,
        totalAmount: r
      }
    })).data;
  }
  async executeMyFatoorahPayment(e, t, r, i) {
    return (await this.request({
      method: "POST",
      path: "/api/app/payment/execute-cart-payment",
      query: {
        sessionId: e,
        cartId: t,
        callbackUrl: r,
        errorCallbackUrl: i
      }
    })).data;
  }
  async testTabbyCustomerEligibility(e) {
    await this.request({
      method: "POST",
      path: "/api/app/tabby/test-customer-eligibility",
      body: e
    });
  }
  async createTamaraSession(e) {
    return (await this.request({
      method: "POST",
      path: "/api/app/tamara/cart-session",
      body: e
    })).data;
  }
  async createTabbySession(e) {
    return (await this.request({
      method: "POST",
      path: "/api/app/tabby/session",
      body: e
    })).data;
  }
}
class ae extends l {
  BASE_PATH = "/api/app/product";
  RESERVATION_PATH = "/api/app/reservation-v2";
  SUBSCRIPTION_PATH = "/api/app/subscription";
  MERCHANDISE_PATH = "/api/app/merchandise-order";
  PROVIDER_PATH = "/api/app/provider";
  constructor(e) {
    super(e);
  }
  async getProduct(e) {
    return (await this.request({
      method: "GET",
      path: `${this.BASE_PATH}/checkout/:productId`,
      params: { productId: e }
    })).data;
  }
  async getSubscriptionPriceAmount(e, t, r, i = {}) {
    const { customFieldValues: a } = i;
    return (await this.request({
      method: "GET",
      path: this.SUBSCRIPTION_PATH + "/price-amount",
      query: { customFieldValues: a, priceId: e, quantity: r, from: t }
    })).data;
  }
  async getMerchandisePriceAmount(e, t, r = {}) {
    const { customFieldValues: i } = r;
    return (await this.request({
      method: "GET",
      path: this.MERCHANDISE_PATH + "/price-amount",
      query: {
        CustomFieldValues: i,
        PriceId: e,
        Quantity: t
      }
    })).data;
  }
  async getReservationPriceAmount(e, t, r, i, a = {}) {
    const { providersIds: n, providerCount: o, customFieldValues: c } = a, h = new URLSearchParams({
      priceId: e,
      from: t,
      to: r,
      quantity: i.toString()
    });
    return n?.length && n.forEach((u) => h.append("providersIds", u)), o && h.append("providerCount", o.toString()), c && Object.entries(c).forEach(([u, m]) => {
      h.append(`CustomFields[${u}]`, m.toString());
    }), (await this.request({
      method: "GET",
      path: `${this.RESERVATION_PATH}/price-amount?${h.toString()}`
    })).data;
  }
  async getAvailablities(e, t, r, i = {}) {
    const {
      quantity: a = 1,
      productProvidersIds: n,
      productProviderCount: o,
      location: c
    } = i, h = new URLSearchParams({
      startDate: t.toLocaleDateString("en-US"),
      endDate: r.toLocaleDateString("en-US"),
      PriceId: e,
      MinQuantity: a.toString()
    });
    c && (c.id && h.append("CustomerLocation.Id", c.id), h.append(
      "CustomerLocation.Longitude",
      c.longitude.toString()
    ), h.append(
      "CustomerLocation.Latitude",
      c.latitude.toString()
    ), c.description && h.append(
      "CustomerLocation.Description",
      c.description.toString()
    ), c.type && h.append(
      "CustomerLocation.Description",
      c.type.toString()
    )), o && !n?.length && h.append("MinProvidersCount", o.toString()), n?.length && n.forEach(
      (u) => h.append("ProvidersIds", u)
    );
    const d = await this.request({
      method: "GET",
      path: `${this.RESERVATION_PATH}/availabilities?${h.toString()}`
    });
    return {
      isLocationApplicable: d.data.isLocationApplicable,
      slots: d.data.slots.map((u) => ({
        ...u,
        from: new Date(u.from),
        to: new Date(u.to),
        maxConnectedTo: u.maxConnectedTo ? new Date(u.maxConnectedTo) : null
      }))
    };
  }
  async getProductsSlots(e) {
    const t = new URLSearchParams({
      date: e.toLocaleDateString("en-US")
    });
    return (await this.request({
      method: "GET",
      path: `${this.RESERVATION_PATH}/products-slots?${t.toString()}`
    })).data;
  }
  async getDateRangeReservations(e) {
    const t = new URLSearchParams();
    return t.append("StartDate", e.startDate), t.append("EndDate", e.endDate), e.includeBooked !== void 0 && t.append("IncludeBooked", e.includeBooked.toString()), e.productIds && e.productIds.forEach((i) => t.append("ProductIds", i)), e.providerIds && e.providerIds.forEach((i) => t.append("ProviderIds", i)), e.customerLocation && (e.customerLocation.id && t.append("CustomerLocation.Id", e.customerLocation.id), t.append(
      "CustomerLocation.Longitude",
      e.customerLocation.longitude.toString()
    ), t.append(
      "CustomerLocation.Latitude",
      e.customerLocation.latitude.toString()
    ), e.customerLocation.description && t.append(
      "CustomerLocation.Description",
      e.customerLocation.description
    ), e.customerLocation.type !== void 0 && t.append(
      "CustomerLocation.Type",
      e.customerLocation.type.toString()
    )), (await this.request({
      method: "GET",
      path: `${this.RESERVATION_PATH}/date-range-reservations?${t.toString()}`
    })).data;
  }
  async getReadOnlyProviders() {
    return (await this.request({
      method: "GET",
      path: this.PROVIDER_PATH + "/read-only-list"
    })).data;
  }
}
var F = /* @__PURE__ */ ((s) => (s.LocalStorage = "localStorage", s.SessionStorage = "sessionStorage", s))(F || {});
class ne {
  config;
  listeners;
  constructor(e) {
    this.listeners = /* @__PURE__ */ new Set(), this.config = this.validateConfig(e);
  }
  getConfig() {
    return this.config;
  }
  updateConfig(e) {
    const t = this.validateConfig({
      ...this.config,
      ...e
    });
    this.config = t, this.notifyListeners();
  }
  subscribe(e) {
    return this.listeners.add(e), () => this.listeners.delete(e);
  }
  isFeatureEnabled(e) {
    return this.config.features?.[e] ?? !1;
  }
  getDefaultConfig() {
    var e = void 0;
    return {
      tenant: "ali",
      broadcastEvents: !0,
      baseUrl: "https://platform.rekaz.io",
      environment: e,
      features: {
        optimisticUpdates: !0,
        retryOnError: !0,
        persistCart: !0,
        validateResponses: !0,
        useCache: !0,
        debug: !1
      },
      storage: {
        type: F.LocalStorage,
        keyPrefix: "cart_sdk_"
      }
    };
  }
  validateConfig(e) {
    return {
      ...this.getDefaultConfig(),
      ...e
    };
  }
  notifyListeners() {
    this.listeners.forEach((e) => e(this.config));
  }
}
const b = {
  /** Default timeout for standard cart operations */
  STANDARD_OPERATION: 1e5,
  /** Extended timeout for order submission */
  ORDER_SUBMISSION: 3e5
};
var _ = /* @__PURE__ */ ((s) => (s.SDK_READY = "sdk:ready", s.CART_MODULE_READY = "sdk:cart:ready", s.PRODUCT_MODULE_READY = "sdk:product:ready", s))(_ || {});
class oe {
  constructor(e) {
    this.services = e, this.events = this.services.events;
  }
  cartMachine = null;
  machineInitialized = !1;
  events = null;
  /**
   * Initialize the cart module
   */
  initialize(e) {
    try {
      if (this.machineInitialized) return;
      this.cartMachine = new W(
        this.services.cartQueryService,
        this.services.storage,
        this.services.errorHandler
      ), this.machineInitialized = !0, console.log("Cart machine initialized", e);
      const t = this.cartMachine.createActor({ cartId: e });
      t.start(), t.on("*", (r) => {
        this.services.events.emit({
          type: r.type,
          data: r.cart || null
        });
      }), t.on(g.CART_CREATED, ({ cart: r }) => {
        this.services.queryClient.setQueryData(["cart", r?.id], r);
      }), this.services.events.emit({
        type: _.CART_MODULE_READY,
        data: null
      });
    } catch (t) {
      throw this.services.errorHandler.handleError(t), t;
    }
  }
  /**
   * Get current cart state
   */
  getState() {
    if (!this.cartMachine)
      throw new Error("Cart machine not initialized. Call initialize() first.");
    const e = this.cartMachine.getState();
    return {
      value: e.value,
      context: e.context,
      cart: e.context.cart,
      isLoading: this.cartMachine.isLoading()
    };
  }
  /**
   * Subscribe to cart state changes
   */
  subscribe(e) {
    if (!this.cartMachine)
      throw new Error("Cart machine not initialized. Call initialize() first.");
    return this.cartMachine.getActor().subscribe((r) => {
      e({
        value: r.value,
        context: r.context,
        cart: r.context.cart,
        isLoading: this.cartMachine.isLoading()
      });
    }).unsubscribe;
  }
  /**
   * Create a new cart
   */
  async create() {
    if (!this.cartMachine)
      throw new Error("Failed to initialize cart machine");
    const t = this.cartMachine.getActor().getSnapshot();
    return t.context.cart ? t.context.cart : this.createPromiseFromEvent(g.CART_CREATED);
  }
  /**
   * Get a cart by ID
   */
  async get(e) {
    if (!this.cartMachine)
      throw new Error("Failed to initialize cart machine");
    const t = this.cartMachine.getState();
    return t.context.cart?.id === e ? t.context.cart : this.services.errorHandler.handleWithRetry(() => this.services.cartApi.getCart(e));
  }
  async getCart(e) {
    return this.services.cartQueryService.getCart(e);
  }
  async refetchCart() {
    if (!this.cartMachine)
      throw new Error("Failed to initialize cart machine");
    return this.cartMachine.send({ type: "REFETCH_CART" }), this.createPromiseFromEvent(g.CART_UPDATED);
  }
  /**
   * Add items to the cart
   */
  async addItems(e, t = !1) {
    if (!this.cartMachine)
      throw new Error("Failed to initialize cart machine");
    if (e.length > 1 && t)
      throw new E(
        "Cannot add multiple items as single item",
        v.INVALID_OPERATION
      );
    return this.cartMachine.send({ type: "ADD_ITEMS", items: e, singleItem: t }), this.createPromiseFromEvent(g.ITEMS_ADDED);
  }
  /**
   * Remove items from the cart
   */
  async removeItems(e) {
    if (!this.cartMachine)
      throw new Error("Failed to initialize cart machine");
    return this.cartMachine.send({ type: "REMOVE_ITEMS", itemIds: e }), this.createPromiseFromEvent(g.ITEMS_REMOVED);
  }
  /**
   * Update items in the cart
   */
  async updateItems(e) {
    if (!this.cartMachine)
      throw new Error("Failed to initialize cart machine");
    return this.cartMachine.send({ type: "UPDATE_ITEMS", items: e }), this.createPromiseFromEvent(g.ITEMS_UPDATED);
  }
  /**
   * Update customer information
   */
  async updateCustomer(e) {
    if (!this.cartMachine)
      throw new Error("Failed to initialize cart machine");
    return this.cartMachine.send({ type: "UPDATE_CUSTOMER", customer: e }), this.createPromiseFromEvent(g.CUSTOMER_UPDATED);
  }
  /**
   * Update the cart note
   */
  async updateNote(e) {
    if (!this.cartMachine)
      throw new Error("Failed to initialize cart machine");
    return this.cartMachine.send({ type: "UPDATE_NOTE", note: e }), this.createPromiseFromEvent(g.NOTES_UPDATED);
  }
  /**
   * Apply a coupon to the cart
   */
  async applyCoupon(e) {
    if (!this.cartMachine)
      throw new Error("Failed to initialize cart machine");
    return this.cartMachine.send({ type: "UPDATE_COUPON", code: e }), this.createPromiseFromEvent(g.COUPON_UPDATED);
  }
  /**
   * Validate a coupon for the given cart items
   */
  async validateCoupon(e, t) {
    return this.services.cartQueryService.validateCoupon(e, t);
  }
  /**
   * Validate the cart
   */
  async validateCart() {
    const e = this.getState?.().cart?.id;
    if (!e)
      throw new E(
        "Cart ID is not available.",
        v.CART_NOT_FOUND
      );
    return this.services.cartQueryService.validateCart(e);
  }
  /**
   * Submit the order for processing
   */
  async submitOrder(e) {
    if (console.log("submitOrder", e), !this.cartMachine)
      throw new Error("Failed to initialize cart machine");
    return this.cartMachine.send({ type: "SUBMIT_ORDER", paymentMethod: e }), this.createPromiseFromEvent(
      g.CART_COMPLETED,
      b.ORDER_SUBMISSION
    );
  }
  /**
   * Set the payment method for the cart
   */
  async setBankTransferInfo(e, t) {
    const r = this.getState?.().cart?.id;
    if (!r)
      throw new E(
        "Cart ID is not available.",
        v.CART_NOT_FOUND
      );
    return this.services.cartQueryService.setBankTransferInfo(
      r,
      e,
      t
    );
  }
  /**
   * Get the bank accounts for the current tenant
   */
  async getBankAccounts() {
    return this.services.cartQueryService.getBankAccounts();
  }
  async getCustomerOrders(e) {
    return this.services.cartQueryService.getCustomerOrders(e);
  }
  isLoading() {
    return this.cartMachine ? this.cartMachine.isLoading() : !0;
  }
  invalidateAllQueries() {
    if (!this.cartMachine)
      throw new Error("Failed to initialize cart machine");
    this.services.queryClient.invalidateQueries({ queryKey: ["cart"] }), this.services.queryClient.invalidateQueries({
      queryKey: ["getCustomerOrders"]
    });
  }
  async subscribeToCartUpdates(e, t, r) {
    const i = await this.services.cartApi.getCartSSE(
      e,
      t
    );
    return i.onmessage = (a) => {
      try {
        const n = JSON.parse(a.data);
        r(n);
      } catch (n) {
        console.error("Failed to parse cart data:", n);
      }
    }, i.onerror = (a) => {
      console.error("SSE connection error:", a), i.close();
    }, i;
  }
  /**
   * Subscribe to cart status updates
   */
  async subscribeToCartStatusUpdates(e, t, r, i) {
    const a = await this.services.cartApi.getCartStatusSSE(
      e,
      t,
      i
    );
    return a.onmessage = (n) => {
      r(n.data);
    }, a.onerror = (n) => {
      console.error("SSE connection error:", n), a.close();
    }, a;
  }
  /**
   * Get an order by ID
   */
  async getOrder(e, t = !0) {
    return this.services.cartQueryService.getOrder(e, t);
  }
  /**
   * Create a promise that resolves when a specific event is emitted
   */
  createPromiseFromEvent(e, t = b.STANDARD_OPERATION) {
    return new Promise((r, i) => {
      const a = this.services.events.once(e, (n) => {
        r(n.data);
      });
      setTimeout(() => {
        a(), i(
          new E(
            "Operation timed out: " + e,
            v.REQUEST_TIMEOUT
          )
        );
      }, t);
    });
  }
}
var S = /* @__PURE__ */ ((s) => (s.RESERVATION = "reservation", s.MERCHANDISE = "merchandise", s.SUBSCRIPTION = "subscription", s.PACKAGE = "package", s))(S || {}), P = /* @__PURE__ */ ((s) => (s.AMOUNTS_UPDATED = "amountsUpdated", s.MERCHANDISE_READY = "merchandiseReady", s.CUSTOM_FIELDS_UPDATED = "customFieldsUpdated", s.ADDONS_UPDATED = "addonsUpdated", s.ERROR = "error", s))(P || {});
const ce = 5;
function Q(s) {
  return {
    product: s,
    priceId: ee(s.pricing)?.id ?? s.pricing[0].id,
    amount: {
      effectiveQuantity: 1,
      totalAfterDiscount: s.amount,
      totalPrice: s.amount
    },
    quantity: 1,
    customFields: void 0,
    addOns: void 0,
    error: void 0,
    errorRetries: 0
  };
}
const ue = (s) => K({
  actors: {
    updateAmounts: V(
      async ({ input: e }) => {
        const { context: t } = e;
        try {
          return await s.getMerchandisePriceAmount(
            t.priceId,
            t.quantity,
            {
              customFieldValues: {
                ...t.customFields,
                ...t.addOns
              }
            }
          );
        } catch (r) {
          throw new q(
            "Failed to update the price amount",
            D.FETCH_AMOUNT_FAILED,
            { error: r }
          );
        }
      }
    )
  },
  actions: {
    resetContext: p(({ context: e }) => Q(e.product)),
    incrementRetries: p({
      errorRetries: ({ context: e }) => e.errorRetries + 1
    }),
    resetRetries: p({
      errorRetries: 0,
      error: void 0
    }),
    changePrice: p({
      priceId: ({ event: e }) => {
        if (e.type !== "CHANGE_PRICE")
          throw new Error("Invalid event type");
        return e.priceId;
      }
    }),
    changeQuantity: p({
      quantity: ({ event: e }) => {
        if (e.type !== "CHANGE_QUANTITY")
          throw new Error("Invalid event type");
        return e.quantity < 1 ? 1 : e.quantity;
      }
    }),
    setAddOns: p({
      addOns: ({ event: e }) => {
        if (e.type !== "SET_ADDONS")
          throw new Error("Invalid event type");
        return e.addOns;
      }
    }),
    setCustomFields: p({
      customFields: ({ event: e }) => {
        if (e.type !== "SET_CUSTOM_FIELDS")
          throw new Error("Invalid event type");
        return e.customFields;
      }
    }),
    emitMerchandiseReadyEvent: f(() => ({
      type: P.MERCHANDISE_READY,
      data: null
    })),
    emitCustomFieldsUpdated: f(({ context: e }) => {
      if (!e.customFields)
        throw new Error(
          "Cannot emit custom fields updated event: No custom fields set"
        );
      return {
        type: P.CUSTOM_FIELDS_UPDATED,
        data: { customFields: e.customFields }
      };
    }),
    emitAddOnsUpdated: f(({ context: e }) => {
      if (!e.addOns)
        throw new Error("Cannot emit add-ons updated event: No add-ons set");
      return {
        type: P.ADDONS_UPDATED,
        data: { addOns: e.addOns }
      };
    }),
    emitPriceAmountUpdate: f(({ context: e }) => ({
      type: P.AMOUNTS_UPDATED,
      data: e.amount
    })),
    emitError: f(({ context: e }) => {
      if (!e.error)
        throw new Error("Cannot emit error event: No error is set");
      return {
        type: P.ERROR,
        data: e.error
      };
    })
  },
  guards: {
    isMerchandiseProductSet: ({ context: e }) => !!e.product,
    hasNoPendingCustomFields: ({ context: e }) => {
      const { product: t } = e;
      return t.customFields.length === 0 || !!e.customFields;
    },
    canRetry: ({ context: e }) => e.errorRetries < ce
  }
}).createMachine({
  id: "MerchandiseMachine",
  initial: "initializing",
  context: ({ input: e }) => Q(e.product),
  states: {
    initializing: {
      entry: "resetRetries",
      always: [
        {
          guard: "isMerchandiseProductSet",
          target: "updatingAmounts"
        },
        {
          target: "error",
          actions: p({
            error: () => new q(
              "Merchandise product not set",
              D.GENERAL_ERROR
            )
          })
        }
      ]
    },
    updatingAmounts: {
      tags: ["loading"],
      invoke: {
        src: "updateAmounts",
        input: ({ context: e }) => ({ context: e }),
        onDone: {
          target: "idle",
          actions: [
            p({
              amount: ({ event: e }) => e.output
            }),
            { type: "emitPriceAmountUpdate" }
          ]
        },
        onError: {
          target: "error",
          actions: p({
            error: ({ event: e }) => e.error
          })
        }
      }
    },
    idle: {
      tags: ["idle"],
      on: {
        CHANGE_PRICE: {
          target: "updatingAmounts",
          actions: "changePrice"
        },
        CHANGE_QUANTITY: {
          target: "updatingAmounts",
          actions: "changeQuantity"
        },
        SET_ADDONS: {
          target: "updatingAmounts",
          actions: [{ type: "setAddOns" }, { type: "emitAddOnsUpdated" }]
        },
        SET_CUSTOM_FIELDS: {
          target: "updatingAmounts",
          actions: [
            { type: "setCustomFields" },
            { type: "emitCustomFieldsUpdated" }
          ]
        }
      }
    },
    merchandiseReady: {
      on: {
        MERCHANDISE_READY: {
          target: "idle",
          actions: "resetContext"
        }
      }
    },
    error: {
      tags: ["error"],
      entry: ["incrementRetries", "emitError"],
      on: {
        RETRY: [
          {
            guard: "canRetry",
            target: "updatingAmounts"
          },
          {
            target: "terminated"
          }
        ],
        RESET: {
          target: "initializing",
          actions: "resetContext"
        }
      }
    },
    terminated: {
      type: "final"
    }
  }
});
class he {
  machine = null;
  actor = null;
  /**
   * Creates a new MerchandiseStateMachine instance
   *
   * @param productQueryService - Service for product-related API operations
   */
  constructor(e) {
    this.machine = ue(e);
  }
  /**
   * Returns the underlying machine instance
   *
   * @returns The XState machine instance
   * @throws Error if the machine is not initialized
   */
  getInstance() {
    if (!this.machine)
      throw new Error("Machine not initialized");
    return this.machine;
  }
  /**
   * Creates an actor instance if one doesn't exist
   *
   * @returns The XState machine instance
   * @throws Error if the machine is not initialized
   */
  createActor(e) {
    if (!this.machine)
      throw new Error("Machine not initialized");
    return this.actor || (this.actor = z(this.machine, {
      input: { product: e.product }
    })), this.actor;
  }
  /**
   * Gets the actor instance, starting it if necessary
   */
  getActor(e) {
    if (!this.actor && e)
      this.actor = this.createActor(e);
    else if (!this.actor)
      throw new Error("Actor not created and no input provided");
    return this.actor.getSnapshot().status !== "active" && this.actor.start(), this.actor;
  }
  /**
   * Gets the current state snapshot of the actor
   */
  getState() {
    return this.getActor().getSnapshot();
  }
  /**
   * Gets the current context of the state machine
   */
  getContext() {
    return this.getState().context;
  }
  /**
   * Sends an event to the state machine
   */
  send(e) {
    this.getActor().send(e);
  }
  /**
   * Checks if the state machine is in a loading state
   */
  isLoading() {
    return this.getState().tags.has("loading");
  }
  /**
   * Checks if the state machine is in an error state
   */
  isError() {
    return this.getState().tags.has("error");
  }
  /**
   * Checks if the state machine is in a processing state
   */
  isProcessing() {
    return this.getState().tags.has("processing");
  }
  /**
   * Gets the current error if the machine is in an error state
   */
  getError() {
    return this.getContext().error;
  }
  /**
   * Sends a retry event to recover from an error state
   */
  retry() {
    this.send({ type: "RETRY" });
  }
  /**
   * Sends a reset event to completely reset the machine
   */
  reset() {
    this.send({ type: "RESET" });
  }
  /**
   * Changes the price ID
   */
  changePrice(e) {
    this.send({ type: "CHANGE_PRICE", priceId: e });
  }
  /**
   * Updates the quantity
   */
  changeQuantity(e) {
    this.send({ type: "CHANGE_QUANTITY", quantity: e });
  }
  /**
   * Sets the add-ons for the merchandise
   */
  setAddOns(e) {
    this.send({ type: "SET_ADDONS", addOns: e });
  }
  /**
   * Sets the custom fields for the merchandise
   */
  setCustomFields(e) {
    this.send({ type: "SET_CUSTOM_FIELDS", customFields: e });
  }
  /**
   * Stops the actor if it's running
   */
  stop() {
    this.actor && this.actor.stop();
  }
}
class de {
  constructor(e) {
    this.services = e;
  }
  merchandiseMachine = null;
  machineInitialized = !1;
  /**
   * Get current merchandise state
   */
  getState() {
    const e = this.getMerchandiseMachine(), t = e.getState();
    return {
      tags: t.tags,
      value: t.value,
      context: t.context,
      isLoading: e.isLoading()
    };
  }
  /**
   * Subscribe to merchandise state changes
   */
  subscribe(e) {
    const t = this.getMerchandiseMachine();
    return t.getActor().subscribe((i) => {
      e({
        tags: i.tags,
        value: i.value,
        context: i.context,
        isLoading: t.isLoading()
      });
    }).unsubscribe;
  }
  /**
   * Create/activate the state machine for a merchandise product
   */
  async create(e, t) {
    try {
      await this.initializeMachine();
    } catch (a) {
      throw this.services.errorHandler.handleError(a), a;
    }
    if (!this.merchandiseMachine)
      throw new Error("Merchandise machine failed to initialize.");
    const r = {
      product: e,
      priceId: t
    }, i = this.merchandiseMachine.createActor(r);
    if (!i)
      throw new Error("Failed to create actor for merchandise product");
    return i.start(), i.on("*", (a) => {
      a.type && this.services.events.emit({
        type: a.type,
        data: a.data
      });
    }), this.services.events.emit({
      type: _.PRODUCT_MODULE_READY,
      data: null
    }), this;
  }
  /**
   * Get the merchandise machine, ensuring it's initialized.
   */
  getMerchandiseMachine() {
    if (!this.merchandiseMachine)
      throw new Error(
        "Merchandise machine not initialized. Call create() first."
      );
    return this.merchandiseMachine;
  }
  /**
   * Change the selected price ID
   */
  changePrice(e) {
    return this.getMerchandiseMachine().changePrice(e), this;
  }
  /**
   * Update the quantity
   */
  changeQuantity(e) {
    return this.getMerchandiseMachine().changeQuantity(e), this;
  }
  /**
   * Set add-ons
   */
  setAddons(e) {
    return this.getMerchandiseMachine().setAddOns(e), this;
  }
  /**
   * Set custom fields
   */
  setCustomFields(e) {
    return this.getMerchandiseMachine().setCustomFields(e), this;
  }
  /**
   * Retry after an error
   */
  retry() {
    return this.getMerchandiseMachine().retry(), this;
  }
  /**
   * Reset the state machine
   */
  reset() {
    return this.getMerchandiseMachine().reset(), this;
  }
  /**
   * Check if loading
   */
  isLoading() {
    return this.merchandiseMachine ? this.merchandiseMachine.isLoading() : !1;
  }
  /**
   * Check if in error state
   */
  hasError() {
    return this.merchandiseMachine ? this.merchandiseMachine.isError() : !1;
  }
  /**
   * Get current error
   */
  getError() {
    return this.merchandiseMachine ? this.merchandiseMachine.getError() : void 0;
  }
  /**
   * Lazily initialize state machine
   */
  async initializeMachine() {
    this.machineInitialized || (this.merchandiseMachine || (this.merchandiseMachine = new he(
      this.services.productQueryService
    )), this.machineInitialized = !0);
  }
  /**
   * Create a promise that resolves when a specific event is emitted
   */
  createPromiseFromEvent(e, t = b.STANDARD_OPERATION) {
    return new Promise((r, i) => {
      const a = this.services.events.once(e, (n) => {
        r(n.data);
      });
      setTimeout(() => {
        a(), i(
          new E("Operation timed out", v.REQUEST_TIMEOUT)
        );
      }, t);
    });
  }
}
class R {
  constructor(e) {
    this.services = e;
  }
  reservationMachine = null;
  machineInitialized = !1;
  /**
   * Create a reservation for a specific product
   */
  async create(e, t, r) {
    try {
      await this.initializeMachine();
    } catch (o) {
      throw this.services.errorHandler.handleError(o), o;
    }
    if (!this.reservationMachine)
      throw new Error("Reservation machine failed to initialize.");
    const i = t || e.pricing[0]?.id;
    if (!i)
      throw new Error("Product has no pricing options");
    const a = {
      product: e,
      initialPriceId: i,
      customerLocation: r
    }, n = this.reservationMachine.createActor(a);
    if (!n)
      throw new Error("Failed to create actor for reservation product");
    return n.start(), n.on("*", (o) => {
      o.type && this.services.events.emit({
        type: o.type,
        data: o.data
      });
    }), this.services.events.emit({
      type: _.PRODUCT_MODULE_READY,
      data: null
    }), this;
  }
  /**
   * Get current reservation state
   */
  getState() {
    const e = this.getReservationMachine(), t = e.getState();
    return {
      tags: t.tags,
      value: t.value,
      context: t.context,
      isLoading: e.isLoading()
    };
  }
  /**
   * Subscribe to reservation state changes
   */
  subscribe(e) {
    const t = this.getReservationMachine();
    return t.getActor().subscribe((i) => {
      e({
        tags: i.tags,
        value: i.value,
        context: i.context,
        isLoading: t.isLoading()
      });
    }).unsubscribe;
  }
  /**
   * Get the reservation machine, ensuring it's initialized
   */
  getReservationMachine() {
    if (!this.reservationMachine)
      throw new Error(
        "Reservation machine not initialized. Call create() first."
      );
    return this.reservationMachine;
  }
  /**
   * Change the selected price ID
   */
  changePrice(e) {
    return this.getReservationMachine().changePrice(e), this;
  }
  /**
   * Select a single date
   */
  selectDate(e) {
    return this.getReservationMachine().selectDate(e), this;
  }
  /**
   * Change the displayed month
   */
  changeMonth(e) {
    return this.getReservationMachine().changeMonth(e), this;
  }
  /**
   * Update the provider IDs
   */
  changeProviderIds(e) {
    return this.getReservationMachine().changeProviderIds(e), this;
  }
  /**
   * Update the provider count
   */
  changeProviderCount(e) {
    return this.getReservationMachine().changeProviderCount(e), this;
  }
  /**
   * Update the quantity
   */
  changeQuantity(e) {
    return this.getReservationMachine().changeQuantity(e), this;
  }
  /**
   * Select a time slot
   */
  selectSlot(e) {
    return this.getReservationMachine().selectSlot(e), this;
  }
  /**
   * Sets starting slot for variable duration
   */
  selectSlotFrom(e, t) {
    return this.getReservationMachine().selectSlotFrom(e, t), this;
  }
  /**
   * Set add-ons
   */
  setAddons(e) {
    return this.getReservationMachine().setAddons(e), this;
  }
  /**
   * Set custom fields
   */
  setCustomFields(e) {
    return this.getReservationMachine().setCustomFields(e), this;
  }
  /**
   * Set the location
   */
  setLocation(e) {
    return this.getReservationMachine().setLocation(e), this;
  }
  /**
   * Retry after an error
   */
  retry() {
    return this.getReservationMachine().retry(), this;
  }
  /**
   * Reset the state machine
   */
  reset() {
    return this.getReservationMachine().reset(), this;
  }
  /**
   * Get the available slots
   */
  getAvailabilities() {
    return this.getReservationMachine().getContext().availabilities;
  }
  /**
   * Get the price for a given product
   */
  async getPriceAmount(e, t, r, i, a = {}) {
    return await this.services.productsApi.getReservationPriceAmount(
      e,
      t,
      r,
      i,
      a
    );
  }
  /**
   * Check if loading
   */
  isLoading() {
    return this.reservationMachine ? this.reservationMachine.isLoading() : !1;
  }
  /**
   * Check if in error state
   */
  hasError() {
    return this.reservationMachine ? this.reservationMachine.isError() : !1;
  }
  /**
   * Get current error
   */
  getError() {
    return this.reservationMachine ? this.reservationMachine.getError() : void 0;
  }
  /**
   * Lazily initialize reservation machine
   */
  async initializeMachine() {
    if (!this.machineInitialized) {
      if (!this.reservationMachine) {
        const e = (await import("./reservation-machine-BrOyOFNE.js").then((t) => t.r)).ReservationStateMachine;
        this.reservationMachine = new e(
          this.services.productQueryService
        );
      }
      this.machineInitialized = !0;
    }
  }
  /**
   * Create a promise that resolves when a specific event is emitted
   */
  createPromiseFromEvent(e, t = b.STANDARD_OPERATION) {
    return new Promise((r, i) => {
      const a = this.services.events.once(e, (n) => {
        r(n.data);
      });
      setTimeout(() => {
        a(), i(
          new E("Operation timed out", v.REQUEST_TIMEOUT)
        );
      }, t);
    });
  }
}
var T = /* @__PURE__ */ ((s) => (s.AMOUNTS_UPDATED = "amountsUpdated", s.SUBSCRIPTION_START_DATE_UPDATED = "subscriptionStartDateUpdated", s.SUBSCRIPTION_READY = "subscriptionReady", s.CUSTOM_FIELDS_UPDATED = "customFieldsUpdated", s.ADDONS_UPDATED = "addonsUpdated", s.ERROR = "error", s))(T || {});
const le = 5;
function H(s) {
  return {
    product: s,
    priceId: s.pricing[0].id,
    amount: {
      effectiveQuantity: 1,
      totalAfterDiscount: s.amount,
      totalPrice: s.amount
    },
    quantity: 1,
    subscriptionStartDate: s.subscriptionStartDate ? new Date(s.subscriptionStartDate) : void 0,
    customFields: void 0,
    addOns: void 0,
    error: void 0,
    errorRetries: 0
  };
}
const pe = (s) => K({
  actors: {
    updateAmounts: V(async ({ input: e }) => {
      const { context: t } = e;
      try {
        const r = t.subscriptionStartDate ? t.subscriptionStartDate.toISOString() : (/* @__PURE__ */ new Date()).toISOString();
        return await s.getSubscriptionPriceAmount(
          t.priceId,
          r,
          t.quantity,
          {
            customFieldValues: {
              ...t.customFields,
              ...t.addOns
            }
          }
        );
      } catch (r) {
        throw new q(
          "Failed to update the price amount",
          D.FETCH_AMOUNT_FAILED,
          { error: r }
        );
      }
    })
  },
  actions: {
    resetContext: p(({ context: e }) => H(e.product)),
    incrementRetries: p({
      errorRetries: ({ context: e }) => e.errorRetries + 1
    }),
    resetRetries: p({
      errorRetries: 0,
      error: void 0
    }),
    changePrice: p({
      priceId: ({ event: e }) => {
        if (e.type !== "CHANGE_PRICE")
          throw new Error("Invalid event type");
        return e.priceId;
      }
    }),
    changeQuantity: p({
      quantity: ({ event: e }) => {
        if (e.type !== "CHANGE_QUANTITY")
          throw new Error("Invalid event type");
        return e.quantity < 1 ? 1 : e.quantity;
      }
    }),
    setSubscriptionStartDate: p({
      subscriptionStartDate: ({ event: e }) => {
        if (e.type !== "SET_SUBSCRIPTION_START_DATE")
          throw new Error("Invalid event type");
        return e.date;
      }
    }),
    setCustomFields: p({
      customFields: ({ event: e }) => {
        if (e.type !== "SET_CUSTOM_FIELDS")
          throw new Error("Invalid event type");
        return e.customFields;
      }
    }),
    setAddOns: p({
      addOns: ({ event: e }) => {
        if (e.type !== "SET_ADDONS")
          throw new Error("Invalid event type");
        return e.addOns;
      }
    }),
    emitSubscriptionReadyEvent: f(() => ({
      type: T.SUBSCRIPTION_READY,
      data: null
    })),
    emitSubscriptionStartDateUpdated: f(({ context: e }) => {
      if (!e.subscriptionStartDate)
        throw new Error(
          "Cannot emit subscription start date updated event: No date is selected"
        );
      return {
        type: T.SUBSCRIPTION_START_DATE_UPDATED,
        data: { date: e.subscriptionStartDate }
      };
    }),
    emitCustomFieldsUpdated: f(({ context: e }) => {
      if (!e.customFields)
        throw new Error(
          "Cannot emit custom fields updated event: No custom fields set"
        );
      return {
        type: T.CUSTOM_FIELDS_UPDATED,
        data: { customFields: e.customFields }
      };
    }),
    emitAddOnsUpdated: f(({ context: e }) => {
      if (!e.addOns)
        throw new Error("Cannot emit add-ons updated event: No add-ons set");
      return {
        type: T.ADDONS_UPDATED,
        data: { addOns: e.addOns }
      };
    }),
    emitPriceAmountUpdate: f(({ context: e }) => ({
      type: T.AMOUNTS_UPDATED,
      data: e.amount
    })),
    emitError: f(({ context: e }) => {
      if (!e.error)
        throw new Error("Cannot emit error event: No error is set");
      return {
        type: T.ERROR,
        data: e.error
      };
    })
  },
  guards: {
    isSubscriptionProductSet: ({ context: e }) => !!e.product,
    isSubscriptionStartDateSet: ({ context: e }) => !!e.subscriptionStartDate,
    hasNoPendingCustomFields: ({ context: e }) => {
      const { product: t } = e;
      return t.customFields.length === 0 || !!e.customFields;
    },
    canRetry: ({ context: e }) => e.errorRetries < le
  }
}).createMachine({
  id: "SubscriptionMachine",
  initial: "initializing",
  context: ({ input: e }) => H(e.product),
  states: {
    initializing: {
      entry: "resetRetries",
      always: [
        {
          guard: "isSubscriptionProductSet",
          target: "updatingAmounts"
        },
        {
          target: "error",
          actions: p({
            error: () => new q(
              "Subscription product not set",
              D.GENERAL_ERROR
            )
          })
        }
      ]
    },
    updatingAmounts: {
      tags: ["loading"],
      invoke: {
        src: "updateAmounts",
        input: ({ context: e }) => ({ context: e }),
        onDone: {
          target: "idle",
          actions: [
            p({
              amount: ({ event: e }) => e.output
            }),
            { type: "emitPriceAmountUpdate" }
          ]
        },
        onError: {
          target: "error",
          actions: p({
            error: ({ event: e }) => e.error
          })
        }
      }
    },
    idle: {
      tags: ["idle"],
      on: {
        CHANGE_PRICE: {
          target: "updatingAmounts",
          actions: "changePrice"
        },
        CHANGE_QUANTITY: {
          target: "updatingAmounts",
          actions: "changeQuantity"
        },
        SET_SUBSCRIPTION_START_DATE: {
          target: "updatingAmounts",
          actions: [
            { type: "setSubscriptionStartDate" },
            { type: "emitSubscriptionStartDateUpdated" }
          ]
        },
        SET_CUSTOM_FIELDS: {
          target: "updatingAmounts",
          actions: [
            { type: "setCustomFields" },
            { type: "emitCustomFieldsUpdated" }
          ]
        },
        SET_ADDONS: {
          target: "updatingAmounts",
          actions: [{ type: "setAddOns" }, { type: "emitAddOnsUpdated" }]
        }
      }
    },
    subscriptionReady: {
      on: {
        SUBSCRIPTION_READY: {
          target: "idle",
          actions: "resetContext"
        }
      }
    },
    error: {
      tags: ["error"],
      entry: ["incrementRetries", "emitError"],
      on: {
        RETRY: [
          {
            guard: "canRetry",
            target: "updatingAmounts"
          },
          {
            target: "terminated"
          }
        ],
        RESET: {
          target: "initializing",
          actions: "resetContext"
        }
      }
    },
    terminated: {
      type: "final"
    }
  }
});
class ye {
  machine = null;
  actor = null;
  /**
   * Creates a new SubscriptionStateMachine instance
   *
   * @param productQueryService - Service for product-related API operations
   */
  constructor(e) {
    this.machine = pe(e);
  }
  /**
   * Returns the underlying machine instance
   *
   * @returns The XState machine instance
   * @throws Error if the machine is not initialized
   */
  getInstance() {
    if (!this.machine)
      throw new Error("Machine not initialized");
    return this.machine;
  }
  /**
   * Creates an actor instance if one doesn't exist
   *
   * @returns The XState machine instance
   * @throws Error if the machine is not initialized
   */
  createActor(e) {
    if (!this.machine)
      throw new Error("Machine not initialized");
    return this.actor || (this.actor = z(this.machine, {
      input: { product: e.product }
    })), this.actor;
  }
  /**
   * Gets the actor instance, starting it if necessary
   */
  getActor(e) {
    if (!this.actor && e)
      this.actor = this.createActor(e);
    else if (!this.actor)
      throw new Error("Actor not created and no input provided");
    return this.actor.getSnapshot().status !== "active" && this.actor.start(), this.actor;
  }
  /**
   * Gets the current state snapshot of the actor
   */
  getState() {
    return this.getActor().getSnapshot();
  }
  /**
   * Gets the current context of the state machine
   */
  getContext() {
    return this.getState().context;
  }
  /**
   * Sends an event to the state machine
   */
  send(e) {
    this.getActor().send(e);
  }
  /**
   * Checks if the state machine is in a loading state
   */
  isLoading() {
    return this.getState().tags.has("loading");
  }
  /**
   * Checks if the state machine is in an error state
   */
  isError() {
    return this.getState().tags.has("error");
  }
  /**
   * Checks if the state machine is in a processing state
   */
  isProcessing() {
    return this.getState().tags.has("processing");
  }
  /**
   * Gets the current error if the machine is in an error state
   */
  getError() {
    return this.getContext().error;
  }
  /**
   * Sends a retry event to recover from an error state
   */
  retry() {
    this.send({ type: "RETRY" });
  }
  /**
   * Sends a reset event to completely reset the machine
   */
  reset() {
    this.send({ type: "RESET" });
  }
  /**
   * Changes the price ID
   */
  changePrice(e) {
    this.send({ type: "CHANGE_PRICE", priceId: e });
  }
  /**
   * Updates the quantity
   */
  changeQuantity(e) {
    this.send({ type: "CHANGE_QUANTITY", quantity: e });
  }
  /**
   * Sets the subscription start date
   */
  setSubscriptionStartDate(e) {
    this.send({ type: "SET_SUBSCRIPTION_START_DATE", date: e });
  }
  /**
   * Sets the custom fields for the subscription
   */
  setCustomFields(e) {
    this.send({ type: "SET_CUSTOM_FIELDS", customFields: e });
  }
  /**
   * Sets the add-ons for the subscription
   */
  setAddOns(e) {
    this.send({ type: "SET_ADDONS", addOns: e });
  }
  /**
   * Stops the actor if it's running
   */
  stop() {
    this.actor && this.actor.stop();
  }
}
class G {
  constructor(e) {
    this.services = e;
  }
  subscriptionMachine = null;
  machineInitialized = !1;
  /**
   * Get current subscription state
   */
  getState() {
    const e = this.getSubscriptionMachine(), t = e.getState();
    return {
      tags: t.tags,
      value: t.value,
      context: t.context,
      isLoading: e.isLoading()
    };
  }
  /**
   * Subscribe to subscription state changes
   */
  subscribe(e) {
    const t = this.getSubscriptionMachine();
    return t.getActor().subscribe((i) => {
      e({
        tags: i.tags,
        value: i.value,
        context: i.context,
        isLoading: t.isLoading()
      });
    }).unsubscribe;
  }
  /**
   * Create/activate the state machine for a subscription product
   */
  async create(e, t) {
    try {
      await this.initializeMachine();
    } catch (a) {
      throw this.services.errorHandler.handleError(a), a;
    }
    if (!this.subscriptionMachine)
      throw new Error("Subscription machine failed to initialize.");
    const r = {
      priceId: t,
      product: e
    }, i = this.subscriptionMachine.createActor(r);
    if (!i)
      throw new Error("Failed to create actor for subscription product");
    return i.start(), i.on("*", (a) => {
      a.type && this.services.events.emit({
        type: a.type,
        data: a.data
      });
    }), this.services.events.emit({
      type: _.PRODUCT_MODULE_READY,
      data: null
    }), this;
  }
  /**
   * Get the subscription machine, ensuring it's initialized.
   */
  getSubscriptionMachine() {
    if (!this.subscriptionMachine)
      throw new Error(
        "Subscription machine not initialized. Call create() first."
      );
    return this.subscriptionMachine;
  }
  /**
   * Change the selected price ID
   */
  changePrice(e) {
    return this.getSubscriptionMachine().changePrice(e), this;
  }
  /**
   * Update the quantity
   */
  changeQuantity(e) {
    return this.getSubscriptionMachine().changeQuantity(e), this;
  }
  /**
   * Set add-ons
   */
  setAddons(e) {
    return this.getSubscriptionMachine().setAddOns(e), this;
  }
  /**
   * Set custom fields
   */
  setCustomFields(e) {
    return this.getSubscriptionMachine().setCustomFields(e), this;
  }
  /**
   * Retry after an error
   */
  retry() {
    return this.getSubscriptionMachine().retry(), this;
  }
  /**
   * Reset the state machine
   */
  reset() {
    return this.getSubscriptionMachine().reset(), this;
  }
  /**
   * Check if loading
   */
  isLoading() {
    return this.subscriptionMachine ? this.subscriptionMachine.isLoading() : !1;
  }
  /**
   * Check if in error state
   */
  hasError() {
    return this.subscriptionMachine ? this.subscriptionMachine.isError() : !1;
  }
  /**
   * Get current error
   */
  getError() {
    return this.subscriptionMachine ? this.subscriptionMachine.getError() : void 0;
  }
  /**
   * Set subscription start date
   */
  setSubscriptionStartDate(e) {
    return this.getSubscriptionMachine().setSubscriptionStartDate(e), this;
  }
  /**
   * Lazily initialize state machine
   */
  async initializeMachine() {
    this.machineInitialized || (this.subscriptionMachine || (this.subscriptionMachine = new ye(
      this.services.productQueryService
    )), this.machineInitialized = !0);
  }
  /**
   * Create a promise that resolves when a specific event is emitted
   */
  createPromiseFromEvent(e, t = b.STANDARD_OPERATION) {
    return new Promise((r, i) => {
      const a = this.services.events.once(e, (n) => {
        r(n.data);
      });
      setTimeout(() => {
        a(), i(
          new E("Operation timed out", v.REQUEST_TIMEOUT)
        );
      }, t);
    });
  }
}
class me {
  constructor(e) {
    this.services = e;
  }
  /**
   * Create appropriate product module based on product type
   * @param product The product to create a module for
   * @returns The type-specific product module
   */
  createModule(e) {
    switch (e.typeString) {
      case S.RESERVATION:
        return new R(this.services);
      case S.SUBSCRIPTION:
      case S.PACKAGE:
        return new G(this.services);
      case S.MERCHANDISE:
        return new de(this.services);
      default:
        throw new Error(`Unsupported product type: ${e.typeString}`);
    }
  }
}
class ge {
  constructor(e) {
    this.services = e, this.factory = new me(e);
  }
  factory;
  activeModule = null;
  productType = null;
  async getProduct(e) {
    return this.services.productQueryService.getProduct(e);
  }
  /**
   * Get current product state
   */
  getState() {
    if (!this.activeModule)
      throw new Error("No product module active. Call create() first.");
    return this.activeModule.getState();
  }
  /**
   * Subscribe to product state changes
   */
  subscribe(e) {
    if (!this.activeModule)
      throw new Error("No product module active. Call create() first.");
    return this.activeModule.subscribe(e);
  }
  /**
   * Create/activate the appropriate module for a specific product
   */
  async create(e, t = e.pricing[0]?.id, r) {
    this.activeModule && this.activeModule.reset();
    try {
      return this.productType = e.typeString, this.activeModule = this.factory.createModule(e), await this.activeModule.create(e, t, r), this;
    } catch (i) {
      throw this.services.errorHandler.handleError(i), i;
    }
  }
  /**
   * Change the selected price ID
   */
  changePrice(e) {
    if (!this.activeModule)
      throw new Error("No product module active. Call create() first.");
    return this.activeModule.changePrice(e), this;
  }
  /**
   * Update the quantity
   */
  changeQuantity(e) {
    if (!this.activeModule)
      throw new Error("No product module active. Call create() first.");
    return this.activeModule.changeQuantity(e), this;
  }
  /**
   * Set add-ons
   */
  setAddons(e) {
    if (!this.activeModule)
      throw new Error("No product module active. Call create() first.");
    return this.activeModule.setAddons(e), this;
  }
  /**
   * Set custom fields
   */
  setCustomFields(e) {
    if (!this.activeModule)
      throw new Error("No product module active. Call create() first.");
    return this.activeModule.setCustomFields(e), this;
  }
  /**
   * Retry after an error
   */
  retry() {
    if (!this.activeModule)
      throw new Error("No product module active. Call create() first.");
    return this.activeModule.retry(), this;
  }
  /**
   * Reset the state machine
   */
  reset() {
    if (!this.activeModule)
      throw new Error("No product module active. Call create() first.");
    return this.activeModule.reset(), this;
  }
  /**
   * Check if loading
   */
  isLoading() {
    return this.activeModule ? this.activeModule.isLoading() : !1;
  }
  /**
   * Check if in error state
   */
  hasError() {
    return this.activeModule ? this.activeModule.hasError() : !1;
  }
  /**
   * Get current error
   */
  getError() {
    return this.activeModule ? this.activeModule.getError() : void 0;
  }
  /**
   * Select a single date (for ReservationModule)
   */
  selectDate(e) {
    if (!this.activeModule)
      throw new Error("No product module active. Call create() first.");
    return this.activeModule instanceof R ? this.activeModule.selectDate(e) : console.warn("selectDate is only applicable to Reservation products."), this;
  }
  /**
   * Change the displayed month (for ReservationModule)
   */
  changeMonth(e) {
    if (!this.activeModule)
      throw new Error("No product module active. Call create() first.");
    return this.activeModule instanceof R ? this.activeModule.changeMonth(e) : console.warn("changeMonth is only applicable to Reservation products."), this;
  }
  /**
   * Update the provider IDs (for ReservationModule)
   */
  changeProviderIds(e) {
    if (!this.activeModule)
      throw new Error("No product module active. Call create() first.");
    return this.activeModule instanceof R ? this.activeModule.changeProviderIds(e) : console.warn(
      "changeProviderIds is only applicable to Reservation products."
    ), this;
  }
  /**
   * Update the provider count (for ReservationModule)
   */
  changeProviderCount(e) {
    if (!this.activeModule)
      throw new Error("No product module active. Call create() first.");
    return this.activeModule instanceof R ? this.activeModule.changeProviderCount(e) : console.warn(
      "changeProviderCount is only applicable to Reservation products."
    ), this;
  }
  /**
   * Select a time slot (for ReservationModule)
   */
  selectSlot(e) {
    if (!this.activeModule)
      throw new Error("No product module active. Call create() first.");
    return this.activeModule instanceof R ? this.activeModule.selectSlot(e) : console.warn("selectSlot is only applicable to Reservation products."), this;
  }
  /**
   * Sets starting slot for variable duration (for ReservationModule)
   */
  selectSlotFrom(e, t) {
    if (!this.activeModule)
      throw new Error("No product module active. Call create() first.");
    return this.activeModule instanceof R ? this.activeModule.selectSlotFrom(e, t) : console.warn(
      "selectSlotFrom is only applicable to Reservation products."
    ), this;
  }
  /**
   * Set the location (for ReservationModule)
   */
  setLocation(e) {
    if (!this.activeModule)
      throw new Error("No product module active. Call create() first.");
    return this.activeModule instanceof R ? this.activeModule.setLocation(e) : console.warn("setLocation is only applicable to Reservation products."), this;
  }
  /**
   * Set subscription start date (for SubscriptionModule)
   */
  setSubscriptionStartDate(e) {
    if (!this.activeModule)
      throw new Error("No product module active. Call create() first.");
    return this.activeModule instanceof G ? this.activeModule.setSubscriptionStartDate(e) : console.warn(
      "setSubscriptionStartDate is only applicable to Subscription products."
    ), this;
  }
  /**
   * Get the available slots (for ReservationModule)
   */
  getAvailabilities() {
    if (!this.activeModule)
      throw new Error("No product module active. Call create() first.");
    return this.activeModule instanceof R ? this.activeModule.getAvailabilities() : (console.warn(
      "getAvailabilities is only applicable to Reservation products."
    ), {
      isLocationApplicable: !1,
      slots: []
    });
  }
  getDateRangeReservations(e) {
    return this.services.productQueryService.getDateRangeReservations(e);
  }
}
class U {
  constructor(e, t) {
    this.errorMonitor = t, this.debug = e.debug || !1, this.retries = e.request?.retries || 3;
  }
  static ERROR_POLICIES = {
    validation: {
      maxRetries: 0,
      backoff: "fixed",
      requiresValidation: !1,
      severity: "error"
    },
    network: {
      maxRetries: 3,
      backoff: "exponential",
      requiresValidation: !0,
      severity: "error",
      recovery: {
        strategy: "retry",
        fallback: "offline"
      }
    },
    business: {
      maxRetries: 1,
      backoff: "fixed",
      requiresValidation: !0,
      severity: "error",
      recovery: {
        strategy: "validate",
        fallback: "reset"
      }
    },
    server: {
      maxRetries: 2,
      backoff: "exponential",
      requiresValidation: !1,
      severity: "fatal"
    }
  };
  debug;
  retries;
  /**
   * Handle API errors with retry logic
   */
  async handleWithRetry(e, t = {}, r = 0) {
    try {
      return await e();
    } catch (i) {
      const a = this.normalizeError(i);
      if (this.errorMonitor.captureError(a, {
        cartId: t.cartId,
        userId: t.userId,
        tags: {
          attempt: String(r),
          errorCode: a.code
        },
        timestamp: (/* @__PURE__ */ new Date()).valueOf()
      }), this.shouldRetry(a, r)) {
        const n = this.getRetryDelay(r);
        return await this.wait(n), this.handleWithRetry(e, t, r + 1);
      }
      throw a;
    }
  }
  /**
   * Handle errors without retry
   */
  handleError(e, t) {
    console.log("is debug", this.debug);
    const r = this.normalizeError(e), i = this.getErrorPolicy(r);
    return this.monitorError(r, t), this.applyRecoveryStrategy(r, i, t);
  }
  /**
   * Convert unknown error to CartError
   */
  normalizeError(e, t) {
    return console.error("Error occurred", e, t), e instanceof E ? e : e instanceof TypeError && e.message.includes("network") ? new x(e.message) : e instanceof Response ? new A(v.API_ERROR, e.statusText, e.status, { url: e.url }) : e instanceof A ? e : e instanceof Error ? new E(
      e.message,
      v.UNKNOWN_ERROR,
      t,
      { originalError: e }
    ) : new E(
      "An unknown error occurred",
      v.UNKNOWN_ERROR,
      t,
      { originalError: e }
    );
  }
  /**
   * Determine if operation should be retried
   */
  shouldRetry(e, t) {
    return t >= this.retries ? !1 : e.retryable;
  }
  /**
   * Calculate delay before retry using exponential backoff
   */
  getRetryDelay(e) {
    const i = 1e3 * Math.pow(2, e), a = Math.random() * 1e3;
    return Math.min(i + a, 1e4);
  }
  wait(e) {
    return new Promise((t) => setTimeout(t, e));
  }
  getErrorPolicy(e) {
    const t = this.categorizeError(e);
    return U.ERROR_POLICIES[t];
  }
  categorizeError(e) {
    return e instanceof x || e instanceof A ? "network" : e.code.startsWith("VALIDATION_") ? "validation" : e.code.startsWith("BUSINESS_") ? "business" : "server";
  }
  async applyRecoveryStrategy(e, t, r) {
    let i = 0;
    if (i >= t.maxRetries)
      return { type: "fail", error: e };
    const a = this.getRetryDelay(i);
    if (await this.wait(a), i++, t.recovery)
      switch (t.recovery.strategy) {
        case "retry":
          return { type: "retry", delay: a };
        case "validate":
          return { type: "validate", then: "retry" };
        case "reset":
          return { type: "reset" };
      }
    return { type: "fail", error: e };
  }
  monitorError(e, t) {
    this.errorMonitor.captureError(e, {
      cartId: t?.cartId,
      tags: {
        errorCode: e.code
      },
      timestamp: (/* @__PURE__ */ new Date()).valueOf()
    });
  }
}
class ve {
  constructor(e = {}) {
    this.defaultTags = e;
  }
  captureError(e, t) {
  }
  captureMessage(e, t) {
  }
  enrichMetadata(e) {
    return {
      ...e,
      timestamp: Date.now(),
      tags: {
        ...this.defaultTags,
        ...e?.tags
      }
    };
  }
}
class Ee {
  listeners;
  domAdapter;
  // TODO: use error handling service
  constructor(e = {}) {
    this.listeners = /* @__PURE__ */ new Map(), e.broadcastToDOM && (this.domAdapter = new fe(this, e.target));
  }
  /**
   * Subscribe to an event
   * @param eventType - The type of event to subscribe to
   * @param callback - Function to be called when the event is emitted
   * @returns Unsubscribe function
   */
  on(e, t) {
    return this.getOrCreateListenerSet(e).add(t), () => this.removeListener(e, t);
  }
  /**
   * Subscribe to an event once
   * @param eventType - The type of event to subscribe to
   * @param callback - Function to be called when the event is emitted
   * @returns Unsubscribe function
   */
  once(e, t) {
    const r = (i) => {
      this.removeListener(e, r), t(i);
    };
    return this.on(e, r);
  }
  /**
   * Emit an event
   * @param event - The event object to emit, following the BaseEvent structure
   */
  emit(e) {
    const t = e.type;
    this.listeners.get(t)?.forEach((i) => {
      try {
        i(e);
      } catch (a) {
        console.error(`Error in event listener for ${t}:`, a);
      }
    }), this.domAdapter?.emit(e);
  }
  /**
   * Remove all listeners for an event or all events
   * @param eventType - Optional event type to clear listeners for
   */
  removeAllListeners(e) {
    e ? this.listeners.delete(e) : this.listeners.clear(), this.domAdapter?.removeAllListeners(e);
  }
  getOrCreateListenerSet(e) {
    let t = this.listeners.get(e);
    return t || (t = /* @__PURE__ */ new Set(), this.listeners.set(e, t)), t;
  }
  removeListener(e, t) {
    const r = this.listeners.get(e);
    r && (r.delete(t), r.size === 0 && this.listeners.delete(e));
  }
}
class fe {
  constructor(e, t = document) {
    this.emitter = e, this.target = t, this.domSubscriptions = /* @__PURE__ */ new Map();
  }
  domSubscriptions;
  /**
   * Emit an event to DOM
   * @param event - The event object to emit to the DOM
   */
  emit(e) {
    const t = new CustomEvent(e.type, {
      detail: e,
      bubbles: !0,
      cancelable: !0
    });
    this.target.dispatchEvent(t);
  }
  /**
   * Listen to DOM events
   * @param eventType - The type of event to listen for
   * @returns Unsubscribe function
   */
  listen(e) {
    const t = this.getOrCreateHandlerSet(e), r = (i) => {
      const n = i.detail;
      n && n.type === e ? this.emitter.emit(n) : console.error(`Invalid or missing event data for ${e}`);
    };
    return t.add(r), this.target.addEventListener(e, r), () => this.removeHandler(e, r);
  }
  /**
   * Remove all listeners for an event or all events
   * @param eventType - Optional event type to remove listeners for
   */
  removeAllListeners(e) {
    e ? this.removeEventListeners(e) : (this.domSubscriptions.forEach((t, r) => this.removeEventListeners(r)), this.domSubscriptions.clear());
  }
  getOrCreateHandlerSet(e) {
    let t = this.domSubscriptions.get(e);
    return t || (t = /* @__PURE__ */ new Set(), this.domSubscriptions.set(e, t)), t;
  }
  removeHandler(e, t) {
    const r = this.domSubscriptions.get(e);
    r && (this.target.removeEventListener(e, t), r.delete(t), r.size === 0 && this.domSubscriptions.delete(e));
  }
  removeEventListeners(e) {
    const t = this.domSubscriptions.get(e);
    t && (t.forEach((r) => {
      this.target.removeEventListener(e, r);
    }), this.domSubscriptions.delete(e));
  }
}
var Se = /* @__PURE__ */ ((s) => (s[s.Unknown = 0] = "Unknown", s[s.Pending = 1] = "Pending", s[s.Active = 2] = "Active", s[s.Confirmed = 3] = "Confirmed", s[s.Cancelled = 4] = "Cancelled", s[s.Suspended = 5] = "Suspended", s[s.Expired = 6] = "Expired", s[s.Paused = 7] = "Paused", s[s.Transferred = 8] = "Transferred", s[s.StartingSoon = 9] = "StartingSoon", s[s.Completed = 10] = "Completed", s))(Se || {}), B = /* @__PURE__ */ ((s) => (s[s.Website = 0] = "Website", s[s.MobileApp = 1] = "MobileApp", s))(B || {});
const Ae = (s) => s.type === S.RESERVATION, Re = (s) => s.type === S.SUBSCRIPTION;
class we {
  constructor(e, t, r = 0) {
    this.productModule = e, this.initialCart = t, this.taxPercentage = r, this.optimisticCart = t, this.taxPercentage = Number(window?.RekazConfig?.configuration.TaxPercentage || 0);
  }
  optimisticCart;
  setOptimisticCart(e) {
    this.optimisticCart = e;
  }
  getOptimisticCart() {
    return this.optimisticCart;
  }
  /**
   * Generates an optimistic cart state based on new items being added.
   *
   * @param newItemsInput - An array of input items to be added.
   * @param prevCart - The previous cart state.
   * @param singleItem - If true, replaces existing items; otherwise, appends.
   * @returns The optimistically updated cart state.
   */
  generateCart(e, t, r) {
    const i = this.productModule?.getState()?.context?.product, { depositAmount: a, effectiveQuantity: n, totalAfterDiscount: o } = this.productModule?.getState()?.context?.amount;
    let c = o;
    i || console.warn(
      "OptimisticService: ProductModule or its context/product is not available. Optimistic items might lack full product details."
    ), i.typeString === S.MERCHANDISE && (c = o / n);
    const h = e.map((u) => {
      const m = {
        id: this.generateUUID(),
        productId: i.id,
        productName: i.name,
        productDescription: i.description,
        product: i,
        quantity: n,
        effectiveQuantity: u.quantity,
        priceId: u.priceId,
        price: i.pricing.find((w) => w.id === u.priceId) ?? null,
        amount: c,
        flatAmount: o,
        depositAmount: a || 0,
        taxAmount: 0,
        customFields: u.customFieldValues || {},
        payableItemGroupId: "",
        payableItemId: ""
      };
      return Ae(u) ? {
        ...m,
        type: S.RESERVATION,
        reservationDateFrom: u.reservationDateFrom,
        reservationDateTo: u.reservationDateTo,
        providersIds: u.providersIds,
        providerCount: u.providerCount
      } : Re(u) ? {
        ...m,
        type: S.SUBSCRIPTION,
        subscriptionStartDate: u.subscriptionStartDate
      } : {
        ...m,
        type: S.MERCHANDISE
      };
    }), d = this.clone(t);
    if (r)
      d.cartItems = h;
    else {
      const u = Array.isArray(t.cartItems) ? t.cartItems : [];
      d.cartItems = [...u, ...h];
    }
    return this.updateCartTotals(d), this.optimisticCart = d, d;
  }
  updateCartTotals(e) {
    let t = 0, r = 0, i = 0;
    for (const m of e.cartItems) {
      const w = typeof m.amount == "number" ? m.amount : 0, O = typeof m.quantity == "number" ? m.quantity : 0, N = typeof m.depositAmount == "number" ? m.depositAmount : 0;
      t += w * O, r += N * O;
    }
    Array.isArray(e.fees) && (i = e.fees.reduce((m, w) => m + (w.amount || 0), 0));
    const a = e.discountAmount || 0, n = t - a, o = this.taxPercentage, c = n * (o / (1 + o)), h = i * o, d = c + h, u = n + i * (1 + o);
    e.subTotal = this.round(t), e.depositAmount = this.round(r), e.discountAmount = this.round(a), e.taxAmount = this.round(d), e.totalAmount = this.round(u), e.hasDeposit = r > 0, e.nonDepositAmount = this.round(e.totalAmount - e.depositAmount), e.amountToBePaid = e.totalAmount, e.taxToBePaid = e.taxAmount;
  }
  round(e) {
    return Math.round(e * 100) / 100;
  }
  clone(e) {
    return JSON.parse(JSON.stringify(e));
  }
  generateUUID() {
    return typeof crypto < "u" && crypto.randomUUID ? crypto.randomUUID() : (console.warn(
      "crypto.randomUUID not available, using fallback UUID generator."
    ), "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
      /[xy]/g,
      function(e) {
        var t = Math.random() * 16 | 0, r = e === "x" ? t : t & 3 | 8;
        return r.toString(16);
      }
    ));
  }
}
class M {
  static instance;
  queryClient;
  constructor() {
    this.queryClient = new j({
      defaultOptions: {
        queries: {
          staleTime: 6e4,
          retry: !1
        }
      }
    });
  }
  static getInstance() {
    return M.instance || (M.instance = new M()), M.instance;
  }
  getQueryClient() {
    return this.queryClient;
  }
}
class L {
  constructor(e) {
    this.api = e, this.queryClient = M.getInstance().getQueryClient();
  }
  queryClient;
  /**
   * Builds a query key for the given arguments. Leaves out any falsy values.
   */
  buildQueryKeys(...e) {
    return e.filter(Boolean);
  }
}
class Ce extends L {
  constructor(e, t, r = null) {
    super(e), this.events = t, this.optimistic = r;
  }
  /**
   * Set or update the optimistic service
   */
  setOptimisticService(e) {
    this.optimistic = e;
  }
  async createCart() {
    return this.queryClient.fetchQuery({
      queryKey: ["cart", "new"],
      queryFn: async () => await this.api.createCart({
        source: B.MobileApp
      })
    });
  }
  async getCart(e) {
    return this.queryClient.fetchQuery({
      queryKey: ["cart", e],
      queryFn: async () => await this.api.getCart(e),
      retry: (t, r) => r?.status === 404 ? !1 : r?.status === 403 ? (localStorage.removeItem("cart_sdk_cartId"), !1) : !0
    });
  }
  async refetchCart(e) {
    return await this.queryClient.invalidateQueries({ queryKey: ["cart", e] }), this.getCart(e);
  }
  async addItems(e, t, r) {
    return new y(this.queryClient, {
      mutationFn: async () => await this.api.addItems(e, t, r),
      onMutate: async () => {
        await this.queryClient.cancelQueries({
          queryKey: ["cart", e]
        });
        const a = this.queryClient.getQueryData([
          "cart",
          e
        ]);
        if (a)
          return this.optimistic && this.queryClient.setQueryData(
            ["cart", e],
            (n) => ({
              ...this.optimistic.generateCart(t, n, r),
              isUpdated: !0
            })
          ), this.events.emit({
            type: g.ITEMS_ADDING,
            data: { cart: a }
          }), { previousCart: a };
      },
      onError: (a, n, o) => (o?.previousCart && this.queryClient.setQueryData(["cart", e], o.previousCart), a),
      onSettled: () => {
        this.queryClient.invalidateQueries({ queryKey: ["cart", e] });
      }
    }).mutate();
  }
  async removeItems(e, t) {
    return new y(this.queryClient, {
      mutationFn: async () => await this.api.removeItems(e, t),
      onMutate: async () => {
        await this.queryClient.cancelQueries({ queryKey: ["cart", e] });
        const i = this.queryClient.getQueryData([
          "cart",
          e
        ]);
        if (i)
          return this.queryClient.setQueryData(["cart", e], (a) => ({
            ...a,
            cartItems: a.cartItems.filter(
              (n) => !t.includes(n.id)
            )
          })), this.events.emit({
            type: g.ITEMS_REMOVING,
            data: { cart: i }
          }), { previousCart: i };
      },
      onError: (i, a, n) => (n?.previousCart && this.queryClient.setQueryData(["cart", e], n.previousCart), i),
      onSettled: () => {
        this.queryClient.invalidateQueries({ queryKey: ["cart", e] });
      }
    }).mutate();
  }
  async updateItems(e, t) {
    return new y(this.queryClient, {
      mutationFn: () => this.api.updateItems(e, t),
      onMutate: async () => {
        await this.queryClient.cancelQueries({ queryKey: ["cart", e] });
        const i = this.queryClient.getQueryData([
          "cart",
          e
        ]);
        if (i)
          return this.queryClient.setQueryData(["cart", e], (a) => ({
            ...a,
            cartItems: a.cartItems.map((n) => {
              const o = t.find((c) => c.id === n.id);
              return o ? { ...n, ...o } : n;
            })
          })), this.events.emit({
            type: g.ITEMS_UPDATING,
            data: { cart: i }
          }), { previousCart: i };
      },
      onError: (i, a, n) => (n?.previousCart && this.queryClient.setQueryData(["cart", e], n.previousCart), i),
      onSettled: () => {
        this.queryClient.invalidateQueries({ queryKey: ["cart", e] });
      }
    }).mutate();
  }
  async updateCoupon(e, t) {
    return new y(this.queryClient, {
      mutationFn: async () => await this.api.updateCoupon(e, t),
      onSettled: () => {
        this.queryClient.invalidateQueries({ queryKey: ["cart", e] });
      }
    }).mutate();
  }
  async validateCoupon(e, t) {
    return new y(this.queryClient, {
      mutationFn: async () => await this.api.validateCoupon({
        couponCode: e,
        cartItems: t
      }),
      onSettled: () => {
        this.queryClient.invalidateQueries({
          queryKey: ["validateCoupon"]
        });
      }
    }).mutate();
  }
  async updateCustomFields(e, t, r) {
    return new y(this.queryClient, {
      mutationFn: async () => await this.api.updateCustomFields(e, t, r),
      onMutate: async () => {
        await this.queryClient.cancelQueries({ queryKey: ["cart", e] });
        const a = this.queryClient.getQueryData(["cart", e]);
        return this.queryClient.setQueryData(["cart", e], (n) => {
          if (n)
            return {
              ...n,
              cartItems: n.cartItems.map((o) => o.id === t ? {
                ...o,
                customFields: {
                  ...o.customFields || {},
                  ...r
                }
              } : o)
            };
        }), { previousCart: a };
      },
      onError: (a, n, o) => (o?.previousCart && this.queryClient.setQueryData(["cart", e], o.previousCart), a),
      onSettled: () => {
        this.queryClient.invalidateQueries({ queryKey: ["cart", e] });
      }
    }).mutate();
  }
  async updateCustomerIdentity(e, t) {
    return new y(this.queryClient, {
      mutationFn: async () => await this.api.updateCustomerIdentity(e, t),
      onMutate: async () => {
        await this.queryClient.cancelQueries({ queryKey: ["cart", e] });
        const i = this.queryClient.getQueryData(["cart", e]);
        return this.queryClient.setQueryData(["cart", e], (a) => ({
          ...a,
          customer: {
            ...a.customer,
            ...t
          }
        })), { previousCart: i };
      },
      onError: (i, a, n) => (n?.previousCart && this.queryClient.setQueryData(["cart", e], n.previousCart), i),
      onSettled: () => {
        this.queryClient.invalidateQueries({ queryKey: ["cart", e] });
      }
    }).mutate();
  }
  async validateCart(e) {
    return this.queryClient.fetchQuery({
      queryKey: ["cart", e, "validate"],
      queryFn: async () => await this.api.validateCart(e),
      retry: !1
    });
  }
  async submitCart(e, t) {
    return new y(this.queryClient, {
      mutationFn: async () => await this.api.submitCart(e, t),
      onSettled: () => {
        this.queryClient.invalidateQueries({ queryKey: ["cart", e] });
      }
    }).mutate();
  }
  async getOrder(e, t = !1) {
    return this.queryClient.fetchQuery({
      queryKey: ["order", e],
      queryFn: async () => await this.api.getOrder(e, t)
    });
  }
  async setBankTransferInfo(e, t, r) {
    return new y(this.queryClient, {
      mutationFn: async () => await this.api.setBankTransferInfo(e, t, r),
      onSettled: () => {
        this.queryClient.invalidateQueries({ queryKey: ["cart", e] });
      }
    }).mutate();
  }
  async getBankAccounts() {
    return this.queryClient.fetchQuery({
      queryKey: ["banks"],
      queryFn: async () => await this.api.getBankAccounts()
    });
  }
  async getCustomerOrders(e) {
    return this.queryClient.fetchQuery({
      queryKey: ["customer-orders"],
      queryFn: async () => await this.api.getCustomerOrders(e)
    });
  }
}
class Te extends L {
  constructor(e) {
    super(e);
  }
  async getCustomerProfile() {
    return this.queryClient.fetchQuery({
      queryKey: ["customer-profile"],
      queryFn: async () => await this.api.getCustomerProfile()
    });
  }
  async updateCustomerProfile(e) {
    return new y(this.queryClient, {
      mutationFn: async () => await this.api.updateCustomerProfile(e),
      onSettled: () => {
        this.queryClient.invalidateQueries({ queryKey: ["customer-profile"] });
      }
    }).mutate();
  }
  async getAllPresets() {
    return this.queryClient.fetchQuery({
      queryKey: ["presets"],
      queryFn: async () => await this.api.getAllPresets()
    });
  }
  async getPresetsWithValues() {
    return this.queryClient.fetchQuery({
      queryKey: ["presets-with-values"],
      queryFn: async () => await this.api.getPresetsWithValues(),
      retry: (e, t) => t.status !== 404
    });
  }
  async getPresetFields(e) {
    return this.queryClient.fetchQuery({
      queryKey: ["preset-fields", e],
      queryFn: async () => await this.api.getPresetFields(e),
      retry: (t, r) => r.status !== 404
    });
  }
  async getPresetValues(e) {
    return this.queryClient.fetchQuery({
      queryKey: ["preset-values", e],
      queryFn: async () => await this.api.getPresetValues(e),
      retry: (t, r) => r.status !== 404
    });
  }
  async getActiveSubscription() {
    return this.queryClient.fetchQuery({
      queryKey: ["active-subscription"],
      queryFn: async () => await this.api.getActiveSubscription(),
      retry: (e, t) => t.status !== 404
    });
  }
  async addPresetValueGroup(e, t) {
    return new y(this.queryClient, {
      mutationFn: async () => await this.api.addPresetValueGroup(e, t),
      onSettled: async () => {
        await this.queryClient.invalidateQueries({
          queryKey: ["presets-with-values"]
        }), await this.queryClient.invalidateQueries({
          queryKey: ["preset-fields", e]
        }), await this.queryClient.refetchQueries({
          queryKey: ["presets-with-values"]
        }), await this.queryClient.refetchQueries({
          queryKey: ["preset-fields", e]
        });
      }
    }).mutate();
  }
  async editPresetValueGroup(e, t) {
    return new y(this.queryClient, {
      mutationFn: async () => await this.api.editPresetValueGroup(e, t),
      onSettled: async () => {
        this.queryClient.invalidateQueries({
          queryKey: ["presets-with-values"]
        }), this.queryClient.invalidateQueries({
          queryKey: ["preset-fields"]
        }), await this.queryClient.refetchQueries({
          queryKey: ["presets-with-values"]
        });
      }
    }).mutate();
  }
  async getCustomerOrders(e = 5, t = 0) {
    return this.queryClient.fetchQuery({
      queryKey: ["customer-orders", e, t],
      queryFn: async () => await this.api.getCustomerOrders(e, t)
    });
  }
  async setDefaultGroup(e) {
    return new y(this.queryClient, {
      mutationFn: async () => await this.api.setDefaultGroup(e),
      onSettled: async () => {
        this.queryClient.invalidateQueries({
          queryKey: ["presets-with-values"]
        }), this.queryClient.invalidateQueries({
          queryKey: ["preset-fields"]
        }), await this.queryClient.refetchQueries({
          queryKey: ["presets-with-values"]
        });
      }
    }).mutate();
  }
  async deletePresetValueGroup(e) {
    return new y(this.queryClient, {
      mutationFn: async () => await this.api.deletePresetValueGroup(e),
      onSettled: async () => {
        this.queryClient.invalidateQueries({
          queryKey: ["presets-with-values"]
        }), this.queryClient.invalidateQueries({
          queryKey: ["preset-fields"]
        }), await this.queryClient.refetchQueries({
          queryKey: ["presets-with-values"]
        });
      }
    }).mutate();
  }
  async getCustomerLocations() {
    return this.queryClient.fetchQuery({
      queryKey: ["customer-locations"],
      queryFn: async () => await this.api.getCustomerLocations()
    });
  }
  async getCustomerLocation(e) {
    return this.queryClient.fetchQuery({
      queryKey: ["customer-location", e],
      queryFn: async () => await this.api.getCustomerLocation(e)
    });
  }
  async addCustomerLocation(e) {
    return new y(this.queryClient, {
      mutationFn: async () => await this.api.addCustomerLocation(e),
      onSettled: () => {
        this.queryClient.invalidateQueries({
          queryKey: ["customer-locations"]
        });
      }
    }).mutate();
  }
  async updateCustomerLocation(e) {
    return new y(this.queryClient, {
      mutationFn: async () => await this.api.updateCustomerLocation(e),
      onSettled: () => {
        this.queryClient.invalidateQueries({
          queryKey: ["customer-locations"]
        }), this.queryClient.invalidateQueries({
          queryKey: ["customer-location", e.id]
        });
      }
    }).mutate();
  }
  async deleteCustomerLocation(e) {
    return new y(this.queryClient, {
      mutationFn: async () => await this.api.deleteCustomerLocation(e),
      onSettled: () => {
        this.queryClient.invalidateQueries({
          queryKey: ["customer-locations"]
        }), this.queryClient.invalidateQueries({
          queryKey: ["customer-location", e]
        });
      }
    }).mutate();
  }
  async getClosestCustomerLocation(e, t) {
    return this.queryClient.fetchQuery({
      queryKey: ["closest-customer-location", e, t],
      queryFn: async () => await this.api.getClosestCustomerLocation(e, t)
    });
  }
  async getCustomerPackages(e, t) {
    return this.queryClient.fetchQuery({
      queryKey: ["customer-packages", e, t],
      queryFn: async () => await this.api.getCustomerPackages(e, t),
      retry: (r, i) => i.status !== 404
    });
  }
}
class Me extends L {
  constructor(e) {
    super(e);
  }
  async getProduct(e) {
    return this.queryClient.fetchQuery({
      queryKey: ["product", e],
      queryFn: async () => await this.api.getProduct(e)
    });
  }
  async getDateRangeReservations(e) {
    return this.queryClient.fetchQuery({
      queryKey: ["date-range-reservations", e.startDate, e.endDate, e.includeBooked, e.productIds, e.providerIds, e.customerLocation],
      queryFn: async () => await this.api.getDateRangeReservations(e)
    });
  }
  async getReservationPriceAmount(e, t, r, i, a = {}) {
    return this.queryClient.fetchQuery({
      queryKey: [
        "price-amount",
        ...this.buildQueryKeys(e, t, r, i, a)
      ],
      queryFn: async ({ signal: n }) => await this.api.getReservationPriceAmount(
        e,
        t,
        r,
        i,
        a
      )
    });
  }
  async getSubscriptionPriceAmount(e, t, r, i = {}) {
    return this.queryClient.fetchQuery({
      queryKey: [
        "price-amount",
        ...this.buildQueryKeys(e, t, r, i)
      ],
      queryFn: async () => await this.api.getSubscriptionPriceAmount(
        e,
        t,
        r,
        i
      )
    });
  }
  async getMerchandisePriceAmount(e, t, r = {}) {
    return this.queryClient.fetchQuery({
      queryKey: [
        "price-amount",
        ...this.buildQueryKeys(e, t, r)
      ],
      queryFn: async () => await this.api.getMerchandisePriceAmount(e, t, r)
    });
  }
  async getAvailablities(e, t, r, i = {}) {
    return this.queryClient.fetchQuery({
      queryKey: [
        "available-slots-v2",
        ...this.buildQueryKeys(e, t, r, i)
      ],
      queryFn: async () => await this.api.getAvailablities(e, t, r, i)
    });
  }
  async getReadOnlyProviders() {
    return this.queryClient.fetchQuery({
      queryKey: ["read-only-providers"],
      queryFn: async () => await this.api.getReadOnlyProviders()
    });
  }
}
class Pe {
  type;
  prefix;
  constructor(e) {
    this.type = e.type || F.LocalStorage, this.prefix = e.keyPrefix || "cart_sdk_";
  }
  async get(e) {
    const t = this.getPrefixedKey(e), r = window[this.type].getItem(t);
    if (!r) return null;
    try {
      return JSON.parse(r);
    } catch {
      return null;
    }
  }
  async set(e, t) {
    const r = this.getPrefixedKey(e);
    window[this.type].setItem(r, JSON.stringify(t));
  }
  async remove(e) {
    const t = this.getPrefixedKey(e);
    window[this.type].removeItem(t);
  }
  async clear() {
    Object.keys(window[this.type]).filter((e) => e.startsWith(this.prefix)).forEach((e) => window[this.type].removeItem(e));
  }
  getPrefixedKey(e) {
    return `${this.prefix}${e}`;
  }
}
class Ie {
  constructor(e) {
    this.errorHandler = e, this.initializeDefaultRules();
  }
  rules = /* @__PURE__ */ new Map();
  customValidators = /* @__PURE__ */ new Map();
  registerRule(e, t) {
    this.rules.set(e, t);
  }
  registerValidator(e, t) {
    this.customValidators.set(e, t);
  }
  async validate(e, t, r = {
    environment: void 0
  }) {
    try {
      const i = await J(t, e), a = await this.validateCustomRules(i, r);
      return {
        isValid: a.errors.length === 0,
        data: i,
        errors: a.errors,
        warnings: a.warnings
      };
    } catch (i) {
      const a = this.handleValiError(i, e);
      return Promise.resolve(a);
    }
  }
  async validateFields(e, t, r, i) {
    const a = Object.fromEntries(
      t.map((n) => [n, e[n]])
    );
    return this.validate(a, r, i);
  }
  async validateCustomRules(e, t) {
    const r = [], i = [];
    for (const [a, n] of this.rules) {
      const o = n.validate(e, t);
      console.log("Validateion:: ", a, n), o.isValid || (n.severity === "error" ? r.push(...o.errors) : i.push(...o.warnings));
    }
    for (const [a, n] of this.customValidators)
      try {
        await n(e, t);
      } catch (o) {
        r.push(this.createValidationError(o, a));
      }
    return { errors: r, warnings: i };
  }
  handleValiError(e, t) {
    return {
      isValid: !1,
      data: t,
      errors: e.issues.map((r) => ({
        code: `VALIDATION_${r.validation}`,
        path: r.path?.map((i) => String(i.key)) ?? [],
        message: r.message,
        context: {
          received: r.received,
          expected: r.expected
        }
      })),
      warnings: []
    };
  }
  createValidationError(e, t) {
    const r = this.errorHandler.normalizeError(e);
    return {
      code: `VALIDATION_${t.toUpperCase()}`,
      path: [],
      message: r.message,
      context: r.details
    };
  }
  initializeDefaultRules() {
  }
}
const _e = [
  "rek.az",
  "mobile.rekaz.io",
  "rekaz.dev",
  "rekaz.io",
  "localhost",
  "127.0.0.1"
];
class Oe {
  constructor(e) {
    this.services = e, this.events = e.events;
  }
  events;
  /**
   * Request an OTP (One-Time Password) for a given phone number and country code
   */
  async requestOtp(e) {
    return await this.services.authApi.requestOtp(e);
  }
  /**
   * Logout the user from the system
   */
  async logout() {
    const e = new URL(window.location.href);
    let t = "";
    localStorage.clear(), sessionStorage.clear(), _e.includes(e.hostname) && (t = window.location.pathname.split("/")[1] ?? ""), window.location.assign(`/${t}/login`);
  }
  /**
   * Login the user using the OTP token and code
   */
  async login(e, t) {
    return await this.services.authApi.login(e, t);
  }
  /**
   * Get the current user information
   */
  async currentUser() {
    return await this.services.authApi.currentUser();
  }
}
class be {
  constructor(e) {
    this.services = e;
  }
  /**
   * Get the customer's profile information
   */
  async getCustomerProfile() {
    return this.services.customerQueryService.getCustomerProfile();
  }
  /**
   * Update the customer's profile information
   */
  async updateCustomerProfile(e) {
    return this.services.customerQueryService.updateCustomerProfile(e);
  }
  /**
   * Get all presets
   */
  async getAllPresets() {
    return this.services.customerQueryService.getAllPresets();
  }
  /**
   * Get presets with their values
   */
  async getPresetsWithValues() {
    return this.services.customerQueryService.getPresetsWithValues();
  }
  /**
   * Get fields for a specific preset
   */
  async getPresetFields(e) {
    return this.services.customerQueryService.getPresetFields(e);
  }
  /**
   * Get values for a specific preset
   */
  async getPresetValues(e) {
    return this.services.customerQueryService.getPresetValues(e);
  }
  /**
   * Invalidate the values for a specific preset
   */
  async invalidatePresetValuesQuery(e) {
    await this.services.queryClient.invalidateQueries({
      queryKey: ["preset-values", e]
    });
  }
  /**
   * Add a new preset value group
   */
  async addPresetValueGroup(e, t) {
    return this.services.customerQueryService.addPresetValueGroup(
      e,
      t
    );
  }
  /**
   * Edit an existing preset value group
   */
  async editPresetValueGroup(e, t) {
    return this.services.customerQueryService.editPresetValueGroup(
      e,
      t
    );
  }
  /**
   * Set a preset group as default
   */
  async setDefaultGroup(e) {
    return this.services.customerQueryService.setDefaultGroup(e);
  }
  /**
   * Delete a preset value group
   */
  async deletePresetValueGroup(e) {
    return this.services.customerQueryService.deletePresetValueGroup(
      e
    );
  }
  /**
   * Get all customer locations
   */
  async getCustomerLocations() {
    return this.services.customerQueryService.getCustomerLocations();
  }
  /**
   * Get a specific customer location by ID
   */
  async getCustomerLocation(e) {
    return this.services.customerQueryService.getCustomerLocation(e);
  }
  /**
   * Add a new customer location
   */
  async addCustomerLocation(e) {
    return this.services.customerQueryService.addCustomerLocation(e);
  }
  /**
   * Update an existing customer location
   */
  async updateCustomerLocation(e) {
    return this.services.customerQueryService.updateCustomerLocation(e);
  }
  /**
   * Delete a customer location
   */
  async deleteCustomerLocation(e) {
    return this.services.customerQueryService.deleteCustomerLocation(
      e
    );
  }
  /**
   * Validate a coupon for the given cart items
   */
  async getCustomerOrders(e = 5, t = 0) {
    return this.services.customerQueryService.getCustomerOrders(
      e,
      t
    );
  }
  /**
   * Get the closest customer location to given coordinates
   */
  async getClosestCustomerLocation(e, t) {
    return this.services.customerQueryService.getClosestCustomerLocation(
      e,
      t
    );
  }
  async getActiveSubscription() {
    return this.services.customerQueryService.getActiveSubscription();
  }
  /**
   * Get customer's active packages with usage information
   * @param customerId - The ID of the customer
   * @param includeAllPackageItems - Whether to include all package items regardless of remaining usage (default: false)
   * @returns Promise of customer package details array
   */
  async getCustomerPackages(e, t) {
    return this.services.customerQueryService.getCustomerPackages(
      e,
      t
    );
  }
}
class qe {
  constructor(e) {
    this.services = e;
  }
  async createMoyasarToken(e, t) {
    return this.services.paymentApi.createMoyasarToken(e, t);
  }
  async createMoyasarSession(e) {
    return this.services.paymentApi.createMoyasarSession(e);
  }
  async createMoyasarApplePaySession(e) {
    return this.services.paymentApi.createMoyasarApplePaySession(e);
  }
  async createMyFatoorahSession(e, t, r) {
    return this.services.paymentApi.createMyFatoorahSession(
      e,
      t,
      r
    );
  }
  async executeMyFatoorahPayment(e, t, r, i) {
    return this.services.paymentApi.executeMyFatoorahPayment(
      e,
      t,
      r,
      i
    );
  }
  async createTamaraSession(e) {
    return this.services.paymentApi.createTamaraSession(e);
  }
  async testTabbyCustomerEligibility(e) {
    return this.services.paymentApi.testTabbyCustomerEligibility(e);
  }
  async createTabbySession(e) {
    return this.services.paymentApi.createTabbySession(e);
  }
}
class xe {
  services;
  optimisticService;
  cart;
  product;
  customer;
  payment;
  auth;
  events;
  constructor(e) {
    console.log("Initializing Rekaz SDK with config"), this.services = this.initializeServices(e), this.product = new ge(this.services), this.optimisticService = new we(this.product, null), this.services.cartQueryService && this.services.cartQueryService.setOptimisticService(
      this.optimisticService
    ), this.cart = new oe(this.services), this.payment = new qe(this.services), this.auth = new Oe(this.services), this.customer = new be(this.services), this.events = this.services.events;
  }
  /**
   * Initialize the SDK
   */
  async initialize() {
    await Promise.all([this.cart.initialize()]), this.services.events.emit({
      type: _.SDK_READY,
      data: null
    }), console.log("SDK initialized");
  }
  /**
   * Update the SDK configuration
   */
  updateConfig(e) {
    this.services.configManager.updateConfig(e);
  }
  /**
   * Check if a feature is enabled
   */
  isFeatureEnabled(e) {
    return this.services.configManager.isFeatureEnabled(e);
  }
  /**
   * Get the query client instance
   */
  getQueryClient() {
    return this.services.queryClient;
  }
  /**
   * Get the current tenant config duh
   */
  getTenantConfig() {
    return this.services.configApi.getTenantConfig();
  }
  /**
   * Get the list of branches
   */
  getBranchList() {
    return this.services.configApi.getBranchList();
  }
  /**
   * Get the list of read only Providers
   */
  getReadOnlyProviders() {
    return this.services.productsApi.getReadOnlyProviders();
  }
  /**
   * Get the current locale
   * @returns The current locale
   */
  getLocale() {
    return this.services.cartApi.getLocale();
  }
  /**
   * Initialize all required services
   */
  initializeServices(e) {
    const t = new ne(e), r = new ve({
      environment: void 0,
      version: e.version || t.getDefaultConfig().version
    }), i = new Ee({
      broadcastToDOM: t.getConfig().broadcastEvents ?? !1
    }), a = new Pe(t.getConfig().storage ?? {}), n = new U(
      t.getConfig(),
      r
    ), o = new Ie(n), c = new te({
      configManager: t,
      errorHandler: n,
      validation: o,
      events: i
    }), h = new ae({
      configManager: t,
      errorHandler: n,
      validation: o,
      events: i
    }), d = M.getInstance().getQueryClient(), u = new Me(h), m = new Ce(c, i), w = new X({
      configManager: t,
      errorHandler: n,
      validation: o,
      events: i
    }), O = new se({
      configManager: t,
      errorHandler: n,
      validation: o,
      events: i
    }), N = new Te(O), Y = new ie({
      configManager: t,
      errorHandler: n,
      validation: o,
      events: i
    }), $ = new re({
      configManager: t,
      errorHandler: n,
      validation: o,
      events: i
    });
    return {
      configManager: t,
      errorHandler: n,
      events: i,
      storage: a,
      queryClient: d,
      cartApi: c,
      cartQueryService: m,
      productsApi: h,
      productQueryService: u,
      authApi: w,
      customerApi: O,
      customerQueryService: N,
      paymentApi: Y,
      configApi: $
    };
  }
}
var De = /* @__PURE__ */ ((s) => (s.Current = "Current", s.Home = "Home", s.Work = "Work", s.RestHouse = "RestHouse", s.FriendsPlace = "FriendsPlace", s.Other = "Other", s))(De || {}), Ne = /* @__PURE__ */ ((s) => (s.NETWORK_ERROR = "NETWORK_ERROR", s.TIMEOUT_ERROR = "TIMEOUT_ERROR", s.UNAUTHORIZED = "UNAUTHORIZED", s.FORBIDDEN = "FORBIDDEN", s.VALIDATION_ERROR = "VALIDATION_ERROR", s.INVALID_PAYLOAD = "INVALID_PAYLOAD", s.INITIALIZATION_FAILED = "INITIALIZATION_FAILED", s.SCRIPT_LOAD_FAILED = "SCRIPT_LOAD_FAILED", s.PAYMENT_FAILED = "PAYMENT_FAILED", s.PAYMENT_DECLINED = "PAYMENT_DECLINED", s.INSUFFICIENT_FUNDS = "INSUFFICIENT_FUNDS", s.CARD_EXPIRED = "CARD_EXPIRED", s.INVALID_CARD = "INVALID_CARD", s.SESSION_CREATION_FAILED = "SESSION_CREATION_FAILED", s.SESSION_EXPIRED = "SESSION_EXPIRED", s.TAMARA_ERROR = "TAMARA_ERROR", s.TABBY_ERROR = "TABBY_ERROR", s.MOYASAR_ERROR = "MOYASAR_ERROR", s.MYFATOORAH_ERROR = "MYFATOORAH_ERROR", s.UNKNOWN_ERROR = "UNKNOWN_ERROR", s.SERVER_ERROR = "SERVER_ERROR", s.CONFIGURATION_ERROR = "CONFIGURATION_ERROR", s))(Ne || {});
class Qe extends Error {
  code;
  statusCode;
  originalError;
  context;
  timestamp;
  requestId;
  constructor(e) {
    super(e.message), this.name = this.constructor.name, this.code = e.code, this.statusCode = e.statusCode, this.originalError = e.originalError, this.context = e.context, this.timestamp = e.timestamp || (/* @__PURE__ */ new Date()).toISOString(), this.requestId = e.requestId, Error.captureStackTrace && Error.captureStackTrace(this, this.constructor);
  }
  toJSON() {
    return {
      code: this.code,
      message: this.message,
      statusCode: this.statusCode,
      context: this.context,
      timestamp: this.timestamp,
      requestId: this.requestId
    };
  }
  toString() {
    return `${this.name}: ${this.message} (${this.code})`;
  }
  isRetryable() {
    return !0;
  }
}
var Fe = /* @__PURE__ */ ((s) => (s[s.String = 1] = "String", s[s.Number = 2] = "Number", s[s.Boolean = 3] = "Boolean", s[s.Date = 4] = "Date", s[s.List = 5] = "List", s[s.Maps = 6] = "Maps", s[s.AddOns = 7] = "AddOns", s[s.MutliSelect = 8] = "MutliSelect", s[s.Radio = 9] = "Radio", s))(Fe || {}), k = /* @__PURE__ */ ((s) => (s.SlotIsNotAvailable = "SP:SlotIsNotAvailable", s.ProviderIsNotAvailable = "SP:ProviderIsNotAvailable", s.MinimumDaysRequirementNotMet = "SP:MinimumDaysRequirementNotMet", s.MaximumDaysExceeded = "SP:MaximumDaysExceeded", s.NextReservationPeriodNotMet = "SP:NextReservationPeriodNotMet", s.OtpCodeMismatch = "SP:OtpCodeMismatch", s.OtpCodeIsExpired = "SP:OtpCodeIsExpired", s.MaxRetriesReached = "SP:MaxRetriesReached", s.ValueIsRequired = "SP:CustomFieldValueIsRequired", s.ValueMustBeNumber = "SP:ValueMustBeNumber", s.ValueMustBeDate = "SP:ValueMustBeDate", s.OptionIsNotValid = "SP:OptionIsNotValid", s.CouponUsageAlreadyExists = "SP:CouponUsageAlreadyExists", s.CouponIsNotActive = "SP:CouponIsNotActive", s.CouponExpired = "SP:CouponExpired", s.CustomerExceededCouponUsage = "SP:CustomerExceededCouponUsage", s.CouponNotFound = "SP:CouponNotFound", s.CouponMinimumCartAmountNotMet = "SP:CouponMinimumCartAmountNotMet", s.CouponReachedMaximumUsage = "SP:CouponReachedMaximumUsage", s.CouponNotApplicableException = "SP:CouponNotApplicable", s.CouponAlreadyExists = "SP:CouponAlreadyExists", s.CustomerNotApplicableException = "SP:CustomerNotApplicableForCoupon", s.ScheduleLinkedWithProviderException = "SP:ScheduleLinkedWithProviderException", s.ProviderLinkedWithProductException = "SP:ProviderLinkedWithProductException", s))(k || {});
function He(s) {
  return Object.values(k).filter((e) => e.includes("Coupon")).includes(s);
}
function Ke(s) {
  return s ? Object.values(k).includes(
    s
  ) : !1;
}
export {
  v as CartErrorCode,
  g as CartEventType,
  W as CartStateMachine,
  I as ContentType,
  Fe as CustomFieldType,
  De as LocationType,
  he as MerchandiseStateMachine,
  Se as OrderItemStatus,
  Qe as PaymentError,
  Ne as PaymentErrorCode,
  Ge as PaymentGatewayProvider,
  C as PaymentMethod,
  k as PlatformDomainErrorCodes,
  S as ProductType,
  _e as REKAZ_DOMAINS,
  xe as RekazSDK,
  D as ReservationErrorCode,
  Ye as ReservationStateMachine,
  ye as SubscriptionStateMachine,
  He as isCouponError,
  Ke as isValidErrorCode
};
//# sourceMappingURL=index.es.js.map
